// Simplified Chinese copy (default language). Keys are dotted namespaces.
export default {
  'app.title': 'Dev Coordinator',
  'app.langToggle': 'EN',

  // AppShell / account menu
  'shell.nav.docs': '文档',
  'shell.nav.submit': '提交 Ticket',
  'shell.nav.myTickets': '我的提交',
  'shell.nav.admin': '管理员功能',
  'shell.nav.approvals': '审批',
  'shell.nav.workItems': '工作项',
  'shell.nav.reports': '汇报',
  'shell.nav.workHours': '工时',
  'shell.nav.help': '帮助',
  // SB-151：各页页头/高危控件旁那枚 ❓（components/HelpLink.jsx）的 aria-label 与
  // tooltip。它指向手册对应章节——文案要说出"去哪、看什么"，不是一个裸的"帮助"。
  'help.link': '查看手册对应章节',
  'shell.nav.open': '打开导航',
  'shell.nav.title': '导航',
  // 第一百一十批：左上角标识换成交通灯字形（🚦横屏／🚥纵屏）。退役了
  // `shell.brand.short`（"DC"）——emoji 取代了它。
  // emoji 不是名字：屏幕阅读器读到的必须是产品名，所以 aria-label 单独一条。
  'shell.brand.aria': 'Dev Coordinator（首页标识）',
  'shell.brand.tipDismiss': '再点一次收起',
  // ── SB-034 工时（成员侧） ──
  'work.title': '工时',
  'work.subtitle': '登记自己的工时。可录入范围为今天前后共 {days} 天（时区：{tz}）。',
  'work.today': '今天',
  'work.noRight': '你的岗位没有登记工时的权限（log_work_hours）。',
  'work.addTitle': '登记工时 · {day}',
  'work.field.backlog': '工单',
  'work.field.hours': '小时',
  'work.field.hours.helper': '0.5 小时为步长',
  'work.field.note': '备注（可选）',
  'work.action.log': '登记',
  'work.action.reverse': '冲正',
  'work.logged': '已登记。',
  'work.reversed': '已冲正。',
  'work.noBacklogs': '当前项目组没有可登记的工单（仅待办/进行中的工单可登记）。',
  'work.dayTotal': '该日已计 {used} / 上限 {cap}',
  'work.rowsTitle': '{day} 的记录',
  'work.noRows': '该日暂无记录。',
  'work.col.backlog': '工单',
  'work.col.hours': '时长',
  'work.col.status': '状态',
  'work.col.actions': '操作',
  'work.status.planned': '规划',
  'work.status.invested': '投入',
  'work.status.migrated': '已迁移',
  'work.status.released': '已释放',
  'work.status.friction': '入摩擦',
  'work.reversalRow': '冲正记录',
  'work.reverse.title': '冲正工时',
  'work.reverse.desc': '已投入的工时不可原地修改，只能追加一条冲正记录抵扣（可少于原时长）。',
  'work.reverse.hours': '冲正小时数',
  'work.reverse.reason': '原因（可选）',
  'work.error.pickBacklog': '请先选择工单。',
  'work.error.halfHour': '时长须为 0.5 小时的正整数倍。',
  'work.error.generic': '操作失败，请重试。',
  // ── 第八十四批：R-08 规划工时的改与删（到期前，仅本人）──
  'work.action.edit': '修改',
  'work.action.delete': '删除',
  'work.edit.title': '修改规划工时',
  'work.edit.desc': '规划中的工时在当天到来之前可以改。原记录会被置为「已释放」并留痕，系统另起一条新记录——账面上看得见改过什么。',
  'work.edit.day': '改到哪一天',
  'work.edit.hours': '改成多少小时',
  'work.edited': '已修改。',
  'work.delete.title': '删除规划工时',
  'work.delete.desc': '这条规划将不再计入任何合计。记录本身不会被抹掉：它会被置为「已释放」并留下操作痕迹（工时记录永不物理删除）。',
  'work.deleted': '已删除。',
  'work.edit.error.noChange': '什么都没改。',
  'work.edit.error.day': '请选择一个日期。',
  'work.edit.error.noRow': '找不到要修改的记录，请刷新后重试。',
  'work.error.alreadyInvested': '这条工时已转为「投入」，不能再改或删——已投入的记录只能追加一条冲正来抵扣（R-36）。',
  'work.error.planDue': '这条规划的日子已经到了：它随时会自动转为「投入」，因此不能再改或删。转投之后可以用冲正抵扣。',
  'work.error.notPlanned': '这条记录已不在规划态（已释放／已迁移／已入摩擦），没有可改可删的东西了。',
  'work.error.gone': '找不到这条记录，或它不是你的。请刷新后重试。',
  // ── 第八十八批：正文的 markdown 渲染，与「显示原文」这个出口 ──
  // ── 第九十批：源码仓的公网克隆地址与凭据用法 ──
  'admin.repos.clone.title': '公网克隆地址（发给协作者用的就是这一条）',
  'admin.repos.clone.howto': '凭据在「Git 访问控制」页按人按仓发放；令牌只显示一次，且可随时回收。克隆时把用户名与令牌填进下面这条命令：',
  'admin.repos.clone.noBase': '本 stage 没有配置对外地址（PUBLIC_BASE_URL），因此给不出可发出去的克隆地址。本地姿态属正常。',
  'body.showSource': '显示原文',
  'body.showRendered': '按 markdown 显示',
  'submit.bodyIsPlainText': '正文按纯文本显示（不做 markdown 渲染）',
  'submit.bodyIsPlainText.hint': '默认按 markdown 渲染。若正文里大量出现的 # * _ 本来就不是格式符号，勾上这项。',
  'backlog.translationPending': '翻译待补',
  'backlog.translationStale': '译文已过期（原文已改）',
  'backlog.translationPendingHint': '该工作项尚无 {lang} 译文，当前显示源语言原文。',
  'backlog.edit': '订正',
  'backlog.editSaved': '已订正。',
  'shell.account.jobPost': '岗位',
  'shell.account.admin': '管理员',
  'shell.group.title': '项目组',
  // 第一百零二批：工具条常驻 Chip / 抽屉头部那一枚的无障碍名与提示。
  'shell.group.aria': '当前项目组：{name}',
  'shell.group.switch': '点击切换项目组',
  'shell.account.editNickname': '编辑昵称',
  'shell.account.logout': '登出',
  'shell.nick.title': '编辑昵称',
  'shell.nick.label': '昵称',
  'shell.nick.helper': '留空则显示邮箱。最多 80 字。',
  'shell.nick.error': '保存昵称失败，请重试。',

  // Login page
  'login.title': '登录 Dev Coordinator',
  'login.subtitle': '仅限受邀协作者。请使用邀请邮箱登录。',
  'login.tab.code': '验证码',
  'login.tab.password': '密码',
  'login.field.email': '邮箱',
  'login.field.code': '验证码',
  'login.field.password': '密码',
  'login.action.sendCode': '发送验证码',
  'login.action.resendIn': '{s} 秒后可重发',
  'login.action.login': '登录',
  'login.hint.codeSent': '若邮箱有效，验证码已发送，请查收邮件。',
  'login.hint.codeCap': '验证码邮件每个地址每天最多发 30 封；多次未收到时请勿反复请求。登录后在右上角头像菜单设置密码，即可改用密码登录、不再依赖验证码。',
  'login.hint.passwordWindow': '密码只在这个浏览器最近 7 天内用验证码登录过之后才能用；刚换过密码的，请确认浏览器没有替你自动填入旧密码。',
  'login.hint.tz': '将按浏览器时区（{tz}）记录你的显示时区，可稍后在设置中调整。',
  'login.error.emailRequired': '请输入邮箱地址。',
  'login.error.emailInvalid': '邮箱格式不正确。',
  'login.error.codeRequired': '请输入验证码。',
  'login.error.passwordRequired': '请输入密码。',
  'login.error.invalidCode': '验证码无效或已过期。',
  'login.error.passwordRefused': '密码登录暂不可用，请改用验证码登录。',
  'login.error.network': '网络错误，请稍后重试。',
  'login.error.generic': '登录失败，请重试。',
  // ── 第八十七批：未读提醒信里的次抛登录链接落地页 ──
  'loginLink.pending': '正在登录…',
  // 后端对四种失效（不存在／已用过／过期／账号已停用）只回一种结果，前端不再分岔。
  'loginLink.invalid': '此登录链接已失效（可能已被使用或已过期）。请改用验证码登录。',
  'loginLink.error': '暂时无法完成登录，请稍后重试；链接可能仍然有效。',
  'loginLink.action.toLogin': '前往登录页',

  // Placeholder pages (M2/M3 stubs) — retained for StubPage/fallback use.

  'common.retry': '重试',
  'common.cancel': '取消',
  'common.close': '关闭',
  'common.save': '保存',
  // ── C6 admin account management ──
  'admin.accounts.title': '账号管理',
  'admin.accounts.subtitle': '增查改停用成员账号。管理员身份由 config 决定、不可在此修改（其行标为只读）。',
  'admin.git.title': 'Git 访问控制',
  'admin.git.issue': '发放凭据',
  'admin.git.username': '用户名',
  'admin.git.repo': '仓库',
  'admin.git.canWrite': '可写',
  'admin.git.label': '备注',
  'admin.git.status': '状态',
  'admin.git.active': '生效中',
  'admin.git.revoked': '已回收',
  'admin.git.revoke': '回收',
  'admin.git.issued': '已发放。',
  'admin.git.revokedOk': '已回收，即时生效。',
  'admin.git.tokenOnce': '令牌仅显示这一次（库中只存哈希），请立即复制交付：',
  'admin.git.conflict': '该用户名已持有生效凭据，请先回收再发放。',
  'admin.git.empty': '暂无凭据。',
  'admin.git.error': '操作失败，请重试。',
  // ── 第一百三十五批：发放可改走定向密送；第一百七十五批措辞随多选校正——
  // 信里列的是**所选各仓的真实克隆地址**（两表化后仓权在授权面，此前一度只有
  // 占位符，措辞与现实脱节过一批）。──────────────────────────────────────────
  'admin.git.deliverInstead': '不当时显示，改为密送给归属账号（信里带所选各仓的真实克隆地址与使用方法）',
  'admin.git.deliverHelper': '系统会签一件指名密件（72 小时内一次性取件），正文含令牌、所选各仓的克隆地址与读写口径，及两种用法：安全法（提示时粘贴，不落盘）与快捷法（嵌入命令，会明文落盘）。仓权此后仍可随时增撤——令牌不变。',
  'admin.git.noGroup': '该账号不属于任何项目组——密件没有落点。先把他加进组，或不勾此项由你亲手交付。',
  'admin.git.delivered': '已发放，并作为密件 #{id} 递给 {who}，{t} 前有效。',
  'admin.git.deliveredHint': '让他去「密件」页取。取走即焚——只有一次机会。克隆地址与用法已在信内，无需另行交代。',
  // ── git 凭据体系改造（内外双线裁定批）：凭据/授权两级管理面 ────────────────
  'admin.git.account': '归属账号',
  'admin.git.accountNone': '（不绑定）',
  'admin.git.boundTo': '归属：{who}',
  'admin.git.repoEmpty': '可发放仓库清单为空——先在后端 stage 配置（gitea 段）登记，再来发放。',
  'admin.git.repoGrants': '{n} 项生效授权',
  'admin.git.service': '服务凭据',
  'admin.git.usage': '使用：{s}',
  'admin.git.usage.never': '从未使用',
  'admin.git.usage.count': '{n} 次',
  'admin.git.readOnly': '只读',
  'admin.git.grant.add': '加授权',
  'admin.git.grant.revoke': '吊销',
  'admin.git.grant.makeWrite': '升为可写',
  'admin.git.grant.makeRead': '降为只读',
  'admin.git.grant.empty': '此凭据尚无授权——不挂授权的凭据什么仓也进不去。',
  'admin.git.grant.allGranted': '可发放的仓库都已授权，无可再加。',
  'admin.git.grantConflict': '后端拒绝了这次授权变更（多半是该仓已有生效授权），刷新后再看。',
  'admin.git.saved': '已更新，即时生效。',
  'admin.git.revokeCredential': '吊销凭据',
  'admin.git.deliverNeedsAccount': '密送要先选归属账号——密件是指名递送的。',
  // ── 第二百零七批（SB-180 (e) 实撞）：多组收件人的密件落点组必选，系统不替你猜 ──
  'admin.git.deliverGroup': '密件落点组',
  'admin.git.deliverGroupHint': '密件会落在所选组的密件清单面。该账号属于多个项目组，落点由你选定——系统不替你猜。',
  'admin.git.deliverNeedsGroup': '该账号属于多个项目组——先选定密件落点组再发放。',
  // ── 第一百七十五批：发放多选仓 ＋ 用法介绍信（系统模板信，不含令牌明文）────
  'admin.git.repos': '仓库（可多选）',
  'admin.git.canWriteAll': '所选各仓可写',
  'admin.git.intro': '发送用法介绍信',
  'admin.git.introSent': '介绍信已入队（系统模板信：列当下生效授权与用法，不含令牌明文）。',
  'admin.git.introQueued': '你给此人还有一封在途站内信——等它发出或撤回后再发介绍信。',
  'admin.git.introConflict': '后端拒绝了这封介绍信（凭据或授权状态刚变了），刷新本页再看。',
  'admin.git.intro.unbound': '未绑定归属账号——介绍信没有收件人可推导。用下方「绑定」控件补上归属即可。',
  // ── 第一百七十七批：既存凭据绑定归属账号（SB-180 (d)）─────────────────────
  'admin.git.bind.why': '此凭据未绑定归属账号（迁移搬来的旧行）——密送与介绍信都以绑定位为收件人。',
  'admin.git.bind.btn': '绑定',
  'admin.git.bind.ok': '已绑定。介绍信与密送推导即刻可用。',
  'admin.git.intro.noGrants': '此凭据没有生效授权——先加授权，信里才有仓可列。',

  // ── 第五十五批 项目组与文档改动追踪开关 ───────────────────────────────────
  'admin.groups.title': '项目组',
  'admin.groups.subtitle': '文档改动追踪的唯一操作面。开启后，发布随镜像带上的历史种子会在服务启动时导入；起算点之前的历史不回溯补录。',
  'admin.groups.empty': '暂无项目组。',
  'admin.groups.slug': '标识',
  'admin.groups.tracking': '文档改动追踪',
  'admin.groups.origin': '起算点 / 开启时间',
  'admin.groups.on': '已开启',
  'admin.groups.off': '未开启',
  'admin.groups.originUnknown': '（无起算提交，按开启时间过滤）',
  'admin.groups.irreversibleNote': '不可关闭',
  'admin.groups.enable': '开启追踪',
  'admin.groups.confirmTitle': '开启「{slug}」的文档改动追踪？',
  'admin.groups.confirmIrreversible': '此操作不可撤销：开启后无法再关闭。',
  'admin.groups.confirmDesc': '起算点取当前已发布版本的提交，此前的改动历史不会回溯补录；此后每次发布都会把该项目组文档树的改动记录随镜像带上并导入。',
  'admin.groups.confirm': '确认开启',
  'admin.groups.enabled': '已开启。历史将在下次发布并重启后开始导入。',
  'admin.groups.irreversible': '文档改动追踪一旦开启即不可关闭。',
  'admin.groups.notFound': '该项目组不存在。',
  'admin.groups.error': '项目组加载失败，请重试。',
  // ── 第八十五批 运行期建组 ────────────────────────────────────────────────
  'admin.groups.name': '名称',
  'admin.groups.createTitle': '新建项目组',
  'admin.groups.createHint': '标识（slug）会成为发布目录的一段，建成后**不可更改**；中英两个名称都必填，目录页按语言各取一个。',
  'admin.groups.slugLabel': '标识（slug）',
  'admin.groups.slugHelp': '2–40 字符，小写字母、数字与单个连字符；首尾不用连字符。',
  'admin.groups.nameZh': '中文名称',
  'admin.groups.nameEn': '英文名称',
  'admin.groups.create': '新建',
  'admin.groups.created': '已建组「{slug}」，并同批建出内置摩擦单 {friction}。',
  'admin.groups.slugTaken': '该标识已被占用，换一个。',
  'admin.groups.err.slug.empty': '请填写标识。',
  'admin.groups.err.slug.length': '标识需 2–40 个字符。',
  'admin.groups.err.slug.uppercase': '标识只收小写——大小写不敏感的文件系统上大小写不同的两个标识会指向同一个目录。',
  'admin.groups.err.slug.charset': '标识只能用小写字母、数字与连字符（不能有点、斜杠或空格）。',
  'admin.groups.err.slug.hyphenEdge': '标识的首尾不能是连字符。',
  'admin.groups.err.slug.hyphenDouble': '标识里不能有连续两个连字符。',
  'admin.groups.err.name.empty': '请填写名称。',
  'admin.groups.err.name.tooLong': '名称过长（上限 80 字节，中文一字算三字节）。',
  // ── SB-202 S3（第三百零八批，需求方指令）：资方进度报告的项目层设置 ────────────
  'admin.groups.report': '资方简报',
  'admin.groups.report.on': '每 {days} 天',
  'admin.groups.report.off': '未启用',
  'admin.groups.report.counts': '收件 {recipients} · 排除 {exclude} 版 · 闸门 {gates}',
  'admin.groups.report.edit': '设置',
  'admin.groups.report.title': '「{slug}」的资方进度报告',
  'admin.groups.report.hint': '每天到期扫描一次：启用且距上一份 ≥ 间隔天数才生成并发出。第一次正式发出之前，请先用命令行的试发（dry run）把同一封信发给自己核格式，再在这里启用。',
  'admin.groups.report.enabled': '启用定期发送',
  'admin.groups.report.everyDays': '汇报间隔（天）',
  'admin.groups.report.everyHelp': '1～60 的整数。',
  'admin.groups.report.recipients': '汇报目标成员（邮箱，一行一个）',
  'admin.groups.report.recipientsHelp': '留空 ⇒ 发给本组所有在用的资方账号。',
  'admin.groups.report.exclude': '从汇报里排除的版本',
  'admin.groups.report.excludeHelp': '逗号或换行分隔，如 v1.8, v1.9——这些版本的功能点与资产不计入分子分母。',
  'admin.groups.report.gates': '里程碑闸门（一行一枚：日期 | 中文 | English）',
  'admin.groups.report.gatesHelp': '如 2026-10-10 | 验收候选 tag | acceptance-candidate tag。报告里的"距闸门 N 天"照这里算。',
  'admin.groups.report.save': '保存',
  'admin.groups.report.saved': '已保存。改动进审计；下一次到期扫描按新设置。',
  'admin.groups.report.unchanged': '没有改动。',
  'admin.groups.report.err.every': '间隔须是 1～60 的整数。',
  'admin.groups.report.err.email': '收件人里有一项不是邮箱。',
  'admin.groups.report.err.version': '版本号过长（上限 40 字符）。',
  'admin.groups.report.err.gate': '闸门须一行一枚：YYYY-MM-DD | 中文 | English。',
  'admin.groups.report.err.rule': '服务端拒绝了这份设置（形状、邮箱或日期）。',
  // 第三百一十三批：同一只面板也挂在「设置」页顶部（需求方在那里找它）
  'admin.groups.report.panelTitle': '资方进度报告 · 项目层设置',
  'admin.groups.report.panelIntro': '每个项目组一行：是否汇报、汇报间隔、汇报目标成员、排除的版本、里程碑闸门。点「设置」改；「账号」页项目组表里的同名按钮是同一只。',
  // ── 第八十五批 工时两参数走管理面 ────────────────────────────────────────
  'admin.workHours.title': '工时参数',
  'admin.workHours.subtitle': '录入窗口与工作日起点。这两个值不在部署配置里——它们与「这次部署了什么代码」无关，改动即时生效并熬得过重启。',
  'admin.workHours.windowDays': '录入窗口（天）',
  'admin.workHours.windowHelp': '以今天为中心的可录入天数，必须是正奇数（R-01）。出厂值 {n}。',
  'admin.workHours.dayStartHour': '工作日起点（小时）',
  'admin.workHours.dayStartHelp': '0–23（R-32）。出厂值 {n}。改动不回溯既有的工时打包结果。',
  'admin.workHours.save': '保存',
  'admin.workHours.saved': '已保存并即时生效。',
  'admin.workHours.noChange': '没有改动。',
  'admin.workHours.error': '工时参数加载失败，请重试。',
  'admin.workHours.err.windowDays.empty': '请填写录入窗口。',
  'admin.workHours.err.windowDays.notInteger': '录入窗口需为整数天。',
  'admin.workHours.err.windowDays.notPositive': '录入窗口需为正数。',
  'admin.workHours.err.windowDays.notOdd': '录入窗口必须是奇数——窗口是「今天居中的 N 天」，偶数没有中心（R-01）。',
  'admin.workHours.err.dayStartHour.empty': '请填写工作日起点。',
  'admin.workHours.err.dayStartHour.notInteger': '工作日起点需为整点小时。',
  'admin.workHours.err.dayStartHour.outOfRange': '工作日起点需在 0–23 之间（R-32）。',
  'admin.accounts.addTitle': '添加成员',
  'admin.accounts.email': '邮箱',
  'admin.accounts.headcount': '代表人数',
  'admin.accounts.jobPost': '岗位',
  'admin.accounts.displayName': '昵称',
  'shell.account.setPassword': '设置密码',
  'shell.account.changePassword': '修改密码',
  'shell.pw.titleSet': '设置密码',
  'shell.pw.titleChange': '修改密码',
  'shell.pw.explain': '密码是便捷通道：在最近一次验证码登录后的 7 天内，可直接用密码登录，免去每次收邮件。验证码登录始终可用，不受密码影响。',
  'shell.pw.label': '新密码',
  'shell.pw.confirm': '再输一次',
  'shell.pw.helper': '至少 8 个字符。',
  'shell.pw.tooShort': '密码至少 8 个字符。',
  'shell.pw.mismatch': '两次输入不一致。',
  'shell.pw.tooCommon': "这个密码太常见，或与你的邮箱前缀相同，请换一个。",
  'shell.pw.error': '密码设置失败，请重试。',
  'shell.pw.setNow': '现在设置',
  'shell.pw.rotateNow': '现在更换',
  'shell.pw.absentHint': '你尚未设置密码。设置后，验证码登录之后的 7 天内可直接用密码登录，无需每次收邮件。',
  'shell.pw.staleHint': '你的密码已超过 90 天未更换，**密码通道已停用**——请设置新密码以恢复。验证码登录不受影响，随时可用。',
  // ── SB-134（第一百一十四批）新版本提示 ──
  'shell.update.hint': '**这个页面跑的不是最新版**。系统在你打开它之后部署过——新功能对它不存在，改过的接口它也不知道。方便时刷新一下；若这个标签页闲置或切到后台，它会自己刷。',
  'shell.update.reload': '立即刷新',
  // ── SB-117（第一百一十三批）到期动作 ──
  'shell.nav.dueActions': '到期动作',
  'shell.due.open': '去处理',
  'shell.due.overdue': '**{n} 件到期动作已经过期**，最久的一件迟了 {days} 天：{title}。它不会自己消失，也没有别的东西会提起它。',
  'shell.due.today': '今天有 {n} 件到期动作要做：{title}。',
  'shell.due.frame': '（触发日 {dueOn}；今天 UTC {utc} ／ 系统时区 {local}）',
  'due.title': '到期动作',
  'due.subtitle': '「某天必须人工做一次」的事。过了那天它不会消失，只会更显眼。',
  'due.empty': '没有待处理的到期动作。',
  'due.col.dueOn': '触发日',
  'due.col.what': '要做什么',
  'due.col.owner': '执行主体',
  'due.col.state': '状态',
  'due.overdueBy': '迟了 {days} 天',
  'due.isToday': '就是今天',
  'due.done': '已做',
  'due.abandon': '放弃',
  'due.settleNote': '留一句话（做了什么 / 为什么放弃）',
  'due.showSettled': '连已落定的一起看',
  'due.settledAt': '已落定',
  'due.settleFailed': '落定失败，请重试。',
  'due.todays': '今天：UTC {utc} ／ 系统时区 {local}。日期后带 Z 的行按 UTC 日比，其余按系统时区日比。',
  'due.frame.local': '系统时区日',
  'due.settledBy.person': '人在本页落定',
  'due.settledBy.workspace': '工作空间落定',
  'due.settledBy.workspaceRef': '工作空间落定（{ref}）',
  'due.settledBy.unknown': '落定者未记录',
  'admin.accounts.clearQuota': '清除今日发信限额',
  'admin.accounts.quotaCleared': '已清除该成员今日的验证码发送限额。',
  'admin.accounts.slug': '成员键',
  'admin.accounts.slug.helper': '文档中引用该成员的稳定标识（小写字母/数字/连字符）。留空则由邮箱前缀生成。',
  'admin.accounts.slug.edit': '成员键可随时修改：列表中直接编辑，回车或移开焦点即保存；清空则恢复未设置。',
  'admin.accounts.slugTaken': '该成员键已被占用，请换一个（与邮箱无关）。',
  'admin.accounts.add': '添加',
  'admin.accounts.created': '账号已创建（首次收码登录即激活）。',
  'admin.accounts.createIncomplete': '请填写邮箱并选择岗位。',
  'admin.accounts.badEmail': '请填写有效的邮箱地址（需含 @）。',
  'admin.accounts.emailExists': '该邮箱已存在账号。',
  'admin.accounts.badRequest': '请求无效：请检查邮箱、岗位或状态。',
  'admin.accounts.notFound': '账号不存在（可能已被移除）。',
  'admin.accounts.conflictEdit': '该账号由 config 托管，不能在此修改。',
  'admin.accounts.updated': '已更新。',
  'admin.accounts.passwordCleared': '密码已清空（下次改用验证码登录）。',
  'admin.accounts.status': '状态',
  // 第一百零七批：最后活动。**不是"最后登录"**——登录一次可以用一个月，而这一列
  // 要回答的是"这个账号最近还在不在用系统"，所以经 API key 的操作同样算数。
  'admin.accounts.lastSeen': '最后活动',
  'admin.accounts.lastSeen.hint': '该账号最近一次带着有效凭据发出请求的时间（含经 API key 的操作）。按 5 分钟量级记录，故显示可能比实际晚几分钟。',
  'admin.accounts.lastSeen.via.session': '会话',
  'admin.accounts.lastSeen.via.key': 'key',
  'time.since.justNow': '刚刚',
  'time.since.minutes': '{n} 分钟前',
  'time.since.hours': '{n} 小时前',
  'time.since.days': '{n} 天前',
  'admin.accounts.actions': '操作',
  'admin.accounts.status.active': '启用',
  'admin.accounts.status.disabled': '停用',
  'admin.accounts.disable': '停用',
  'admin.accounts.enable': '启用',
  'admin.accounts.resetPassword': '清空密码',
  'admin.accounts.pending': '待激活',
  'admin.accounts.configManaged': 'config 托管',
  'admin.accounts.forbidden': '需要管理员权限。',
  'admin.accounts.error': '操作失败，请重试。',
  'common.error.network': '网络错误，请稍后重试。',
  'common.error.session': '登录状态已失效，请重新登录。',

  // ── Ticket type / status labels (shared by submit + my-tickets) ──────────
  'ticketType.bug': '缺陷',
  'ticketType.incident': '事故',
  'ticketType.maintenance': '维护',
  'ticketType.tech_debt': '技术债',
  'ticketType.spec_change': '规格变更',
  'ticketType.self_intro': '自我介绍',
  'ticketType.asset': '素材提交',
  'ticketType.assigned': '指派单',   // SB-190（第二百四十五批）：ASK-，响应时钟的承载
  'ticketStatus.pending': '待处理',
  'ticketStatus.processing': '处理中',
  'ticketStatus.accepted': '已受理',
  'ticketStatus.rejected': '已拒绝',
  'ticketStatus.info_requested': '待补充信息',
  'ticketStatus.withdrawn': '已撤回',
  'ticketStatus.reported': '已上报',
  'ticketStatus.confirmed': '已确认',
  'ticketStatus.handling': '处理中',
  'ticketStatus.reviewed': '已复核',
  'ticketStatus.published': '已发布',
  // SB-190 §3.1：A 机三态——「待响应」说的是受指派人头上那只钟，不是发出方
  'ticketStatus.assigned': '待响应',
  'ticketStatus.responded': '已响应',
  'ticketStatus.closed': '已关闭',

  // ── M2 document browser ──────────────────────────────────────────────────
  'docs.title': '文档',
  'docs.tree.empty': '暂无可见文档。',
  // 第一百一十一批：这个组还没有任何发布产物（内容通道刚通、还没并进来），
  // 与「发布过但按你的职位一篇都看不到」是两件事——服务端的 contentState 区分了
  // 它们，这里必须跟着分开说，否则那次区分在产品面上等于没发生。
  'docs.tree.neverPublished': '这个项目组还没有发布过文档——不是你看不到，是内容还没并进来。',
  // 第一百一十一批处置轮：正文面的过时横幅。这三句落在**人真正读文档的那一页上**——
  // 树那一侧的 stale_pending 只在空树时才被查，而这一态恰恰只在非空树上才有意义。
  // ⚠ behindUnknown 是承重的一句：「算不出来」绝不许被渲染成「已是最新」。
  'docs.content.stalePending': '你读到的**不是**对方最新的那一版：有比本页发布时间更新的内容投递还没并进来。',
  'docs.content.behindBy': '发布面比对方最近一次投递落后约 {hours} 小时。',
  'docs.content.behindUnknown': '落后多久**算不出来**（缺一侧时刻）——请把「可能已过时」当作默认，不要读成「已是最新」。',
  'docs.tree.error': '加载目录失败。',
  'docs.tree.noGroup': '这个账号还没有加入任何项目组——请管理员在管理页为你分配项目组。',
  'docs.tree.expandAll': '全部展开',
  'docs.tree.collapseAll': '全部折叠',
  'docs.content.placeholder': '从左侧目录中选择一篇文档查看。',
  'docs.content.error': '加载文档失败。',
  'docs.content.notFoundTitle': '文档不存在',
  'docs.content.notFoundDesc': '该文档不存在，或对你不可见。',
  'docs.content.forbiddenTitle': '无访问权限',
  'docs.content.forbiddenDesc': '该文档存在，但你的岗位无权查看其内容。',
  'docs.content.langUnavailableTitle': '当前语言未发布',
  'docs.content.langUnavailableDesc': '该文档在当前语言（{lang}）尚未发布。',
  'docs.content.availableLangs': '可用语言：{langs}',
  // 2026-08-18 外来单语发布模式（SOP-14 §7）：只有 zh 原文的文档在 en 界面下照给
  // zh 内容，但要一句说明——不造假 en 页，也不让读者以为页面坏了。
  'docs.content.zhOnlyNotice': '此文档仅有中文原文。',
  'docs.content.proposeChange': '对本文档提改',
  'docs.content.switchTo': '切换到 {lang}',
  'docs.link.unsupported': '该链接指向文件夹，暂不支持跳转。',
  'docs.link.broken': '该链接的目标文档不存在（发布时已记为断链）。',
  'docs.content.back': '返回',
  // 第一百零三批：可见职位（audience）曝光——方便成员互相沟通「谁看得见这篇」。
  'docs.audience.label': '可见职位',
  'docs.audience.none': '仅管理员可见',

  // ── 第五十五批 文档改动追踪 ───────────────────────────────────────────────
  'docs.content.updatedAt': '更新于 {time}',
  'docs.content.updatedTip': '{time} · 提交 {ref}',
  'docs.content.history': '修改历史',
  'docs.history.title': '修改历史',
  'docs.history.empty': '该文档自追踪开启以来还没有改动记录。',
  'docs.history.error': '加载修改历史失败。',
  'docs.history.disabled': '该项目组尚未开启文档改动追踪。',
  'docs.history.range': '第 {from}–{to} 条，共 {total} 条',
  'docs.history.newer': '更近',
  'docs.history.older': '更早',
  'docs.history.committer': '工作空间',
  'docs.history.event': '随定稿 {no} 上线',
  'docs.history.noEvent': '未关联定稿',
  'docs.history.diffEmpty': '本条未保留改动正文（体量上限内已裁剪）。',
  'docs.history.diffError': '加载改动明细失败。',

  // ── M3 submit ticket ─────────────────────────────────────────────────────
  'submit.title': '提交 Ticket',
  'submit.subtitle': '提交人取当前登录账号；提交后可在“我的提交”中跟踪状态。',
  'submit.field.type': '类型',
  'submit.field.title': '标题',
  'submit.field.body': '描述',
  'submit.field.submitLang': '提交语言',
  'submit.field.projectGroup': '项目组',
  'submit.field.targetDoc': '目标文档',
  'submit.field.targetDoc.helper': '由文档浏览器的"对本文档提改"带入。点 × 可移除并改为手填数值 id。',
  'submit.field.targetDocId': '目标文档 id（高级）',
  'submit.field.targetDocId.helper': '高级回退：手填目标文档的数值 id。一般请在文档浏览器打开目标文档后点"对本文档提改"，自动带入 docKey。',
  'submit.hint.selfIntro': '提交你的自我介绍初稿（能力罗列 / 精力分配 / 自声明的自发责任心归属范围）。提交后操作者会在 AI 辅助下逐层追问补充，经你确认后作为任务指派与进度预估的依据。',
  'submit.hint.asset': '素材提交：把样本文件作为附件上传（可接收的类型与上限以下方附件栏为准；正文写明来源与选择理由；受托征集时填写下方关联工单号）。',
  'submit.field.relatedBacklog': '关联工单号（选填）',
  'submit.field.relatedBacklog.helper': '受托征集素材时填写对应的 BL- 工单号，便于工作空间归集；将写入正文首行。',
  // SB-190 §8（第二百四十五批）：指派单分支。受指派人发出时即定、事后不改（「标记事后不补」），
  // 所以字段话术要把「不可改」说在前面；派生自（P3）只是指回原单，原单一字不动。
  'submit.hint.assigned': '指派单：由审批人或管理员发出、指名一位受指派人作答。受指派人在发出那一刻定下，之后不能改；对方会收到通知，并在「我的工单」里看到这张单和响应入口。关闭由你或审批人来做，受指派人只能响应。',
  'submit.field.assignee': '受指派人',
  'submit.field.assignee.helper': '从下拉里挑人（输入即过滤）。发出后不可更换——问错了人就关闭本单、另开一张。',
  'submit.field.derivedFrom': '派生自（选填）',
  'submit.field.derivedFrom.helper': '若这张指派单是从某张既有工单追问出来的，填它的编号（如 BUG-000012）；原单不会被改动。',
  'submit.error.assigneeRequired': '指派单需要指定受指派人。',
  // SB-190 §3.1 P2（第二百四十七批）：201 回执带 responseDeadline，规则为 1bd_defer 时多说一句
  // ——P2 是顺延时钟而不是拒绝事项，所以提示而不拦。{n}＝该日在本件之前已有几件，{k}＝合同阈值
  //（SLA_SAME_DAY_THRESHOLD，与 defaults.h 同数），两个数都由代码插，不手写。
  'submit.assigned.deferred': '该成员当日已有 {n} 件要求响应的事项，本件时钟自次一工作日 00:00 起算（合同：同一工作日超过 {k} 件即顺延）。',
  // 附件话术一律由 attachments.mjs 的 ATTACH_KINDS 表组装（族名 + 扩展名 + 容量），
  // 不再手写整句——手写的那一版在后端加了 pdf/heic 之后半年没跟上，界面一直在说"不收"。
  'submit.attach.label': '附件（{kinds}）',
  'submit.attach.kind.image': '图片',
  'submit.attach.kind.doc': '文档',
  'submit.attach.kind.audio': '音频',
  'submit.attach.kind.video': '视频',
  'submit.attach.kind.package': '安装包',
  // 2026-09-17 裁定新增两族：动画（riv，Rive 运行时文件）与 3D 模型（glb/gltf，为将来预留）。
  'submit.attach.kind.animation': '动画',
  'submit.attach.kind.model': '3D 模型',
  'submit.attach.kind.archive': '压缩包',
  'submit.attach.kindSpec': '{kind} ≤{mb}MB（{exts}）',
  'submit.attach.kindSep': '，',
  'submit.attach.add': '选择文件',
  'submit.attach.helper': '最多 {n} 个；{groups}。演示稿请导出 PDF（不收 ppt/pptx）。提交工单后逐个上传。',
  'submit.attach.uploaded': '附件已上传 {n} 个。',
  'submit.attach.failed': '{n} 个附件上传失败。失败的文件仍留在下方，可就地重试或移除；工单已经建好，不要撤回、也不要另交一张新工单。',
  'submit.attach.retry': '重试上传（{n} 个失败）',
  'submit.attach.remove': '移除',
  'submit.attach.state.failed': '上传失败',
  'submit.attach.state.done': '已上传',
  // 挑选时的预校验（第五十八批 C1）。必须**指名道姓**：哪个文件、它多大、上限多少——
  // 一句"文件过大"没法让人在十张相册照片里认出是哪一张（IMG_4021.jpg 之间只看名字
  // 分不出来），而 AST-000011 正是因为少了一张、正文那张"按附件顺序排列"的表全错位。
  'submit.attach.state.rejected': '未加入',
  'submit.attach.reject.size': '{name}（{size}）超过{kind}上限 {mb}MB，未加入。请压缩后重挑，或改用可接收的其他类型。',
  'submit.attach.reject.type': '{name}（{ext}）不是可接收的类型，未加入。可接收的类型见下方说明。',
  'submit.attach.reject.empty': '{name} 是空文件（0 字节），未加入。请确认文件已完整拷贝或下载完毕。',
  'submit.attach.rejectedNotice': '有 {n} 个文件没有通过检查，不会随本次提交上传（下方标红并写明了原因）。若正文里按附件顺序列了清单，请先处理这些文件再提交，否则清单会与实际附件错位。',
  'submit.attach.order': '第 {n} 个附件（按上传顺序）',
  'submit.attach.max': '最多 {n} 个附件，多出的 {dropped} 个未加入。',
  // 补传面的额度是「这张工单还剩几个」，不是「一次能挑几个」——两者不同，话术必须分开，
  // 否则一张已有 7 个附件的工单会显示"最多 3 个附件"，读起来像规则变了。
  'submit.attach.maxRemaining': '这张工单还能再传 {n} 个附件（每单上限 {total} 个），多出的 {dropped} 个未加入。',
  'submit.attach.quotaLeft': '这张工单还能再传 {n} 个附件（每单上限 {total} 个）。',
  'submit.attach.quotaFull': '这张工单的附件已达上限（{total} 个），不能再传；还有材料请在说明里写清楚，或联系处理人。',
  'submit.attach.blocked': '工单 {no} 已经建好，还有 {n} 个附件没传上去。请在上面重试上传，或移除这些文件——不要再提交一张新工单。',
  // 重试只重传失败项。提交之后新挑的文件**不会**跟着传到上一张工单上——这句话必须在
  // 屏幕上，否则用户以为"重试 = 把列表里的都传上去"，而结果是照片落到别人的工单里。
  'submit.attach.pendingNext': '另外 {n} 个是你提交之后新挑的文件，不会传到 {no}——重试只重传失败的那些，新文件留给你的下一次提交。',
  // 逐附件备注（第五十九批 E1）。AST-000011 是手打了一张「按附件顺序排列」的表，
  // 少上传一张之后从第 3 行起全部错位——所以这里的话术一个字都不能提"顺序"：
  // 说明是**跟着这个文件**走的，清单按文件名与附件 id 对应，与顺序无关。
  'submit.attach.note.label': '这个文件的说明（选填）',
  'submit.attach.note.placeholder': '来源；类别；拍的是什么',
  // ── SB-067 二期（第六十五批）：机器译文徐呈 ──────────────────────────────
  // OQ-B27：原文始终并存且为准。标记必须显眼——未校译文冒充权威文本正是
  // OQ-A1②/A19 当初要防的那件事。
  'locale.heading': '译文（{lang}）',
  'locale.machine': '机器翻译·未校',
  'locale.pending': '译文生成中，稍后刷新可见。原文在上方，且始终以原文为准。',

  // ── SB-078 L2（第六十六批）：agent 预读 ──────────────────────────────────
  // 每一句都在说同一件事：**这是草稿，裁的人是你**。这个 agent 的建议准确率一次
  // 都还没被验证过，措辞不能有半点"它已经定了"的意思。
  'agentReview.title': 'AI 预读',
  'agentReview.draftChip': '草稿·未裁',
  'agentReview.badge': '{n} 个问题',
  'agentReview.recommended': '建议',
  'agentReview.singleSelect': '单选',
  'agentReview.multiSelect': '多选',
  'agentReview.other': '也可以都不选，自己写一个。',
  'agentReview.answerLater': '本页暂时只呈现问题，作答与裁决记录稍后上线（仍走工作空间）。',
  'agentReview.askSubmitter': '需要向提交人核实的事实（不是问你的）：',
  'agentReview.showRec': '查看 AI 的建议裁决与理由',
  'agentReview.hideRec': '收起建议',
  'agentReview.rec.accept': '建议：受理',
  'agentReview.rec.reject': '建议：不受理',
  'agentReview.rec.request_info': '建议：请提交人补充信息',
  'agentReview.rec.need_ruling': '建议：需要你来裁',

  // ── SB-076 期二（第六十六批 L3）：作答 ──────────────────────────────────
  // **答完即转态**（需求方本批裁）。措辞要让人清楚这一次点击真的会动工单，
  // 而不是"先存个草稿"。
  'agentReview.otherPlaceholder': '都不选，自己写一个（选填）',
  'agentReview.notePlaceholder': '给提交人的说明（选填；会进工单反馈）',
  'agentReview.action.accept': '受理',
  'agentReview.action.reject': '不受理',
  'agentReview.action.request_info': '请补充信息',
  'agentReview.submit': '提交裁决并推进工单',
  'agentReview.submitting': '提交中…',
  'agentReview.missing': '还有 {n} 道题没答（答不上来就写在「都不选」里）',
  'agentReview.pickAction': '选一个动作',
  'agentReview.ruledBy': '{who} 裁决',
  'agentReview.round': '第 {n} 轮',
  'agentReview.stale': '这条裁决所依赖的口径已经变了（{why}），系统已重新排一次预读',
  'agentReview.err.generic': '提交失败，工单没有被改动。',
  'agentReview.err.alreadyRuled': '这道题已经有人先裁了——先到先得。刷新看看结论。',
  'agentReview.err.staleQuestion': '题目变了：agent 在你读页面之后重新读过这张工单。刷新后重新作答。',
  'agentReview.err.staleDraft': '工作项草案变了：agent 在你读页面之后重新读过这张工单。刷新后重读草案再决定要不要采纳。',
  'agentReview.err.staleAsk': 'agent 在你读页面之后重跑过，给提交人的问题已经不是屏幕上这几条了。重读之后再决定。',
  'agentReview.err.conflict': '这张工单现在不能裁（可能有人正在处理，或它已经结案）。',
  'agentReview.err.staleGround': '这份预读所依赖的口径已经变了，本次裁决没有执行（工单未改动）。系统已重新排了一次预读，稍后刷新重答。',
  'agentReview.derived': '已建工作项 {no}，并关联到本工单。',
  // 通知里那条"等你裁"
  'notif.ruling_requested': '工单 {no} 等你裁决',
  'notif.workspace_note': '来自工作空间的消息',

  // ── SB-067 一期（第六十四批）：AI 润色 ────────────────────────────────────
  'polish.button': 'AI 润色',
  'polish.busy': '润色中…',
  'polish.revert': '还原我写的',
  'polish.remaining': '今日还剩 {n}/{limit} 次',
  'polish.done': '已替换为润色稿。不满意就按「还原我写的」。',
  'polish.err.tooShort': '太短了，先多写几个字再润色——字太少的话它只能替你编。',
  'polish.err.tooLong': '这段太长，超出本处的上限。',
  'polish.err.scene': '内部错误：润色场景无效。',
  'polish.err.exhausted': '今天的润色次数用完了，明天再来（按你的时区算）。',
  'polish.err.unavailable': '模型服务暂时不可用，这次不计次数。原文没有被改动。',
  // 这条是本功能唯一的硬判据对外的样子：润色稿改写了编号/路径 ⇒ 整次作废。
  'polish.err.altered': '润色稿改写了不能改的内容（编号、路径或链接），已作废，原文保持不变；这次不计次数。',
  'polish.err.rejected': '这段内容不适合润色。',
  'polish.err.generic': '润色没成功，原文保持不变。',
  'polish.altered.list': '被改掉的：{items}',

  // 第六十二批 SB-073：说明现在**随文件一起上传**、落在附件行上（不再需要复制粘贴）。
  // 上一版的话术让人以为写完就好了，实际上那段文本无处可贴——67 件附件、备注全空。
  'submit.attach.note.hint': '写在这里的说明会**随文件一起上传**，直接挂在那个附件上——不必复制粘贴，也不会因为少传一个文件而错位。一句话就够（"我家猫"、"办公桌"）。',
  'submit.attach.notes.about': '本块由页面依据 {n} 个上传成功的附件自动生成：每行按附件 id 与落库文件名对应，与正文顺序无关。请勿手工改动（要改请改附件的说明后重新生成）。',
  'submit.attach.notes.title': '附件说明清单（已生成 {n} 条）',
  'submit.attach.notes.copy': '复制清单',
  'submit.attach.notes.copied': '清单已复制到剪贴板。',
  'submit.attach.notes.copyFailed': '这个浏览器不让页面写剪贴板，请手动全选复制上面的文本。',
  // 诚实话术：后端没有「改正文」这个接口（routes_me.cpp 的 me 家族只有建单、传附件、
  // 补充回复、撤回四个写入口），正文一经提交就是只读的。清单是在附件上传**之后**才
  // 算得出来的——那时正文已经落库。所以这里不假装贴进了正文，而是把它交到手上。
  'submit.attach.notes.bodyLocked': '你写的说明**已经随每个文件一起交上去了**（挂在附件本身上，处理人打开工单就能看到）。下面这张清单只是给你自己核对用的——不需要复制，也不需要贴到任何地方。',
  'submit.attach.notes.pendingLocked': '这张工单的正文已经不能改了。清单已生成在下面，请复制保存；处理人向你请补信息时，粘进回复框即可（届时页面也会自动带上）。',
  // 第三百六十二批：指派单（ASK-）提出方的补传面。上一句是四类单的话术——「处理人请补信息」
  // 「回复框」在指派单上都不存在，照搬就是许下做不到的承诺。三件事要说清：说明已随文件交上去；
  // 补传不会单独通知受指派人（ticket-state-machine §8.4 记着的已知行为）；首次作答之后窗即关。
  'submit.attach.notes.askIssuer': '说明已随每个文件一起交上去（挂在附件本身上，受指派人打开这张指派单就能看到）；下面这张清单只给你自己核对，不必复制，也无处可贴——指派单没有给发出方的回复框。补传附件不会单独通知受指派人，要他留意请另行告知。受指派人首次作答之后，附件与说明都不能再改。',
  'submit.attach.notes.inReply': '附件说明清单已随这次回复一起提交（{n} 条，按文件名与附件 id 对应）。',
  'submit.attach.notes.willRide': '下面这张清单会随你点「重新提交」一起交上去（{n} 条，按文件名与附件 id 对应），不必手工复制。',
  'submit.attach.notes.orphan': '有 {n} 条说明没有进入清单——它们对应的文件没有上传成功。清单只收**真的传上去**的附件，这是它不会错位的代价：请先把那些文件传上去，说明会自动补进清单。',
  'attach.formulaRisk': '此表格文件含以 =、+、-、@ 开头的单元格，用 Excel/表格软件打开时可能自动执行公式。请先另存后用纯文本查看，或在电子表格里选择「不启用公式」。',
  // 探测器只是「尽力而为的升级信号」，绕过它只要两个字符——所以凡表格文件都提醒一句，
  // 命中探测的才升级为告警（上一条）。受害者是逐个下载附件的评审人，不是服务器。
  'attach.packageCaution': '安装包（apk）：请勿在工位上打开或安装。先把下方 sha256 与提交方另行声明的值核对一致，再只装到测试机（SOP-09 §4）。',
  'attach.archiveCaution': '压缩包（zip）：请先读工单正文里的声明（解压后有哪些文件、各自做什么），再解包；解包只在 temp/ 下进行，不在仓内直接展开。实际内容与声明对不上，请求补材料而不是自行推断（SOP-09 §5）。',
  'attach.csvCaution': '这是表格文件（csv）：用 Excel/表格软件打开时，以 =、+、-、@ 开头的单元格可能被当作公式执行。建议先用纯文本查看，或在电子表格里选择「不启用公式」。',
  'submit.hint.simpleTypes': '缺陷 / 维护 / 技术债 / 事故 无需目标文档，可直接提交。',
  'submit.action.submit': '提交',
  'submit.action.viewMine': '查看我的提交',
  'submit.success': '提交成功，编号 {no}。',
  'submit.error.titleRequired': '请填写标题。',
  'submit.error.targetDocRequired': 'spec_change 需要指定目标文档（请从文档浏览器"对本文档提改"带入）。',
  'submit.error.forbidden': '当前职位无提交 ticket 权限。',
  'submit.error.groupsUnavailable': '无法获取项目组列表，暂时无法提交。请稍后重试。',
  'submit.error.generic': '提交失败，请重试。',

  // ── M3 my tickets ────────────────────────────────────────────────────────
  'tickets.title': '我的提交',
  'tickets.empty': '你还没有提交过 ticket。',
  'tickets.emptyFiltered': '没有符合筛选条件的 ticket。',
  'tickets.error': '加载提交列表失败。',
  'tickets.filter.status': '状态',
  'tickets.filter.all': '全部',
  'tickets.filter.archived': '显示已归档',
  'tickets.col.no': '编号',
  'tickets.col.type': '类型',
  'tickets.col.title': '标题',
  'tickets.col.updated': '更新时间',
  'tickets.archivedChip': '已归档',
  // 第一百零三批：工单三面（审批列表/我的提交/详情头）的组徽标提示。
  'tickets.groupChip.tip': '所属项目组',
  'tickets.action.submitNew': '去提交',
  'tickets.count': '{n} 项',
  'tickets.detail.body': '正文',
  'tickets.detail.feedback': '处理反馈',
  'tickets.detail.attachments': '附件',
  'tickets.detail.timeline': '状态时间线',
  'tickets.detail.author.me': '我',
  'tickets.detail.author.handler': '处理方',
  'assetView.untitled': '（无说明）',
  'assetView.zoomIn': '放大',
  'assetView.zoomOut': '缩小',
  'assetView.reset': '还原',
  'assetView.hintOn': '透明区提示：开',
  'assetView.hintOff': '透明区提示：关',
  'assetView.download': '下载原件',
  'assetView.help': '滚轮或双击缩放（以光标为锚点），放大后可拖拽平移；「还原」回到适应视口。',
  'assetView.helpTouch': '双指捏合缩放，放大后单指拖拽平移；点图片外的空白处或「关闭」即可退出。',
  'docs.tree.show': '展开目录',
  'docs.tree.hide': '收起目录',
  // ── /admin/settings（SB-068/SB-077/SB-084，第六十八批）─────────────────────
  // ── 第八十批：用户 API key（会话等价凭据，仅管理员代签）──────────────────
  'admin.apiKeys.title': '用户 API 密钥',
  'admin.apiKeys.scopeNote': '密钥等价于该成员的登录会话：能做的事与他在页面上完全一样，'
    + '但一律**不能**进入管理页与审批页（管理操作请在页面上做）。密钥不是工作空间令牌，两者互不通用。',
  'admin.apiKeys.usageNote': '用法：在请求头里带 Authorization: Bearer <密钥>。'
    + '密钥泄露等同于该成员的账号被冒用——请立刻回收并重签。',
  'admin.apiKeys.issue': '代签密钥',
  'admin.apiKeys.account': '账号',
  'admin.apiKeys.pickAccount': '先选一个账号。',
  'admin.apiKeys.label': '用途备注',
  'admin.apiKeys.expiresInDays': '有效天数',
  'admin.apiKeys.expiresHint': '留空 = 不过期',
  'admin.apiKeys.status': '状态',
  'admin.apiKeys.active': '生效中',
  'admin.apiKeys.expired': '已过期',
  'admin.apiKeys.revoked': '已回收',
  'admin.apiKeys.revoke': '回收',
  'admin.apiKeys.createdAt': '签发于',
  'admin.apiKeys.expiresAt': '过期于',
  'admin.apiKeys.lastUsed': '最近使用',
  'admin.apiKeys.never': '不过期',
  'admin.apiKeys.neverUsed': '从未使用',
  'admin.apiKeys.issued': '已签发。',
  'admin.apiKeys.revokedOk': '已回收，下一次请求即失效。',
  'admin.apiKeys.keyOnce': '密钥仅显示这一次，关闭后无法再看到（库里只存哈希）。'
    + '请立刻复制并交给本人；弄丢了只能回收重签：',
  'admin.apiKeys.disabledAccount': '该账号已停用，请先启用再签发密钥。',
  'admin.apiKeys.empty': '该账号暂无密钥。',
  'admin.apiKeys.error': '操作失败，请重试。',
  // ── SB-148 C：onboarding 快捷发送（模板站内信；正文由服务端渲染，绝不含 key 明文）──
  'admin.apiKeys.onboarding.send': '发 onboarding 站内信',
  'admin.apiKeys.onboarding.sent': '已发送',
  'admin.apiKeys.onboarding.sentOk': 'onboarding 站内信已发出。模板信不排队，他下次进入页面就会读到。',
  'admin.apiKeys.onboarding.error': 'onboarding 站内信发送失败，请重试。',
  'admin.apiKeys.onboarding.rejected': '服务端拒绝了这封 onboarding 信',
  // ── 第一百八十三批：每把 key 的客户端版本（旧版只做软提醒，不拒请求）──
  'admin.apiKeys.client': '客户端',
  'admin.apiKeys.client.behind': '落后',
  'admin.apiKeys.client.upgrade': '需升级',
  'admin.apiKeys.client.refs': '服务端当前版 {cur}；最低支持 {min}。旧版不拒请求，请提醒本人 selfupdate。',
  'admin.subnav.accounts': '账号管理',
  'admin.subnav.git': 'Git 访问控制',
  'admin.subnav.apiKeys': 'API 密钥',
  'admin.subnav.settings': '服务设置',
  'admin.subnav.logs': '运行日志',
  'admin.subnav.repos': '源码仓',
  'admin.subnav.burn': '工时燃耗',
  'adminBurn.title': '工时燃耗对账',
  'adminBurn.subtitle': '按计费周（周一~周日）汇总各成员工时净额，区间 {from} ~ {to}（上周+本周）。口径与成员工时页同源：净额 = 记录 − 冲正，终态行不计。',
  'adminBurn.member': '成员',
  'adminBurn.thisWeek': '本周净额',
  'adminBurn.lastWeek': '上周净额',
  'adminBurn.days': '日分布',
  'adminBurn.empty': '区间内没有任何工时记录。成员录入后这里会按周汇总。',
  'adminBurn.error': '燃耗数据加载失败。',
  'adminBurn.capNote': '周额线为 demo 外包合同（修正案一）的约定：开工周 60h，8/17 起 40h；单日 ≥9h 以警示色标出。额度线随 demo 结束失效。',
  'admin.repos.title': '源码仓浏览',
  'admin.repos.subtitle': '粗略查看仓库里有什么。文本文件直接展示，二进制只提供下载；只到分支，不含提交历史。',
  'admin.repos.repo': '仓库',
  'admin.repos.branch': '分支',
  'admin.repos.branchOnly': '只到分支——本页不提供提交历史',
  'admin.repos.root': '/',
  'admin.repos.name': '名称',
  'admin.repos.size': '大小',
  'admin.repos.emptyDir': '这个目录是空的。',
  'admin.repos.binary': '二进制',
  'admin.repos.binaryHint': '二进制文件不在页面上展示，请下载后用合适的程序打开。',
  'admin.repos.tooLarge': '文本过大',
  'admin.repos.tooLargeHint': '这是文本文件，但有 {size}，超过了直接展示的上限 {limit}。截断的文本看起来像完整的，所以这里只提供下载。',
  'admin.repos.download': '下载',
  'admin.repos.notFound': '这个分支下没有这个路径。',
  'admin.repos.notProvisioned': 'git 桥尚未供给令牌，因此读不到任何仓库内容。这不是权限问题——请先配置后端的 gitea 令牌。',
  'admin.repos.error': '读取仓库失败，请重试。',
  // ── 第八十一批：运行日志页 ────────────────────────────────────────────────
  'admin.logs.title': '运行日志',
  'admin.logs.intro': '这一页回答的是「刚才出了什么事」。日志按时间倒序，重启标记会插在对应的位置——看日志时的第一个问题往往是「这条报错是这次启动之后的吗」。',
  'admin.logs.filters.from': '起始时间',
  'admin.logs.filters.to': '结束时间',
  'admin.logs.filters.level': '级别',
  'admin.logs.filters.levelAll': '全部级别',
  'admin.logs.filters.levelHint': '选中的级别及其以上（error 最高）',
  'admin.logs.filters.category': '类别',
  'admin.logs.filters.categoryHint': '精确匹配，不是模糊匹配',
  'admin.logs.filters.regex': '正则（同时匹配类别、正文与明细）',
  'admin.logs.filters.regexHint': 'ECMAScript 正则；写坏了会被服务端以 400 挡回，不会静默变成「没有结果」',
  'admin.logs.filters.icase': '忽略大小写',
  'admin.logs.filters.pageSize': '每页',
  'admin.logs.apply': '查询',
  'admin.logs.reset': '重置',
  'admin.logs.refresh': '刷新',
  'admin.logs.total': '命中 {n} 条',
  'admin.logs.page': '第 {page} / {pages} 页',
  'admin.logs.prev': '上一页',
  'admin.logs.next': '下一页',
  'admin.logs.detail': '明细',
  'admin.logs.col.time': '时间',
  'admin.logs.col.level': '级别',
  'admin.logs.col.category': '类别',
  'admin.logs.col.message': '内容',
  'admin.logs.empty': '这段时间没有符合条件的日志。请注意下面两件事再下结论：写入级别可能把它们挡在了库外，队列溢出也可能丢过行——这两种情况与「确实很太平」在屏幕上长得一样。',
  'admin.logs.writeLevel': '写入级别：{level}',
  'admin.logs.writeLevelHint': '当前实际生效的写入闸。比它低的级别根本不会落库——所以「查不到 debug」很可能不是没发生，而是没被记下来。',
  'admin.logs.dropped': '丢弃 {n} 条',
  'admin.logs.droppedHint': '写入队列溢出时会丢行并计数。丢过行还不说，就是在展示一份看起来完整的残缺记录。',
  'admin.logs.restartMarker': '服务重启 · {note}',
  'admin.logs.restartsUnavailable': '重启标记这次没取到（日志本身正常）。缺了它就无法判断某条报错属于哪一次启动。',
  'admin.logs.err.range': '结束时间早于起始时间。',
  'admin.logs.err.regex': '正则写坏了，服务端拒绝了这次查询。请修正后重试。',
  'admin.logs.err.absent': '这个节点没有配置文件型运行日志库，查不到任何行（这不是「今天很太平」）。',
  'admin.logs.err.load': '日志读取失败，请重试。',

  // 被交出的站内信（第一百零九批 P1 ②：举报窄通道的管理面）
  // intro 必须写清这条通道的边界：你读得到的**只有**被收件人主动交出的那几封，
  // 其余任何一封你仍然读不到。少了这一句，下一个管理员会以为这里是"全部站内信"，
  // 而那正好是这条窄通道最容易被误解成的东西。
  'admin.reported.title': '被交出的站内信',
  'admin.reported.intro': '收件人主动交给管理员的信，一次一封。你在这里读到的只有这些——其余任何一封站内信对你仍然不存在，包括这几封的当事人之间的其它往来。交出不可撤回，发送方不会被通知。',
  'admin.reported.empty': '没有人交出过站内信。',
  'admin.reported.err': '交出的站内信读取失败——这不是“没有人举报”，是这条通道此刻取不到数据。',
  'admin.reported.who': '{from} 写给 {to}',
  'admin.reported.when': '发出 {sent} · 收件人读于 {read} · 交出于 {reported}',
  'admin.reported.noBody': '这一封的正文取不回来（响应里没有它）。别把它读成“信是空的”。',
  // ── 第八十一批：作业队列（此前四个计数无人渲染）────────────────────────────
  'admin.settings.jobs.title': '作业队列',
  'admin.settings.jobs.intro': '译文、预读这类后台作业排在这里。只看计数答得了「有没有失败」，答不了「为什么」——所以失败行一并给出重试次数与最后一次的报错原文。',
  'admin.settings.jobs.state.pending': '排队中',
  'admin.settings.jobs.state.running': '执行中',
  'admin.settings.jobs.state.done': '已完成',
  'admin.settings.jobs.state.failed': '已失败',
  'admin.settings.jobs.noFailures': '没有失败的作业。',
  'admin.settings.jobs.col.job': '作业',
  'admin.settings.jobs.col.entity': '对象',
  'admin.settings.jobs.col.attempts': '尝试次数',
  'admin.settings.jobs.col.lastError': '最后一次报错（服务端原文）',
  'admin.settings.invalidModel': '该型号当前设不了',
  'agentReview.langNote': '题面按提交语言显示（{lang}）',
  'agentReview.toolTrace': '预读查阅了 {n} 处仓内容：',
  'admin.settings.title': '服务设置 · 各步骤的模型',
  'admin.settings.intro': '这里改的是**系统在每个步骤调用 LLM 时用哪个模型**。改动即刻生效，且**重新部署不会把它抹掉**（OQ-B28 二期分键裁定：模型选择可运行期覆盖）。同一行显示三个值——部署值、你设的覆盖、实际生效值——因为它们会不一致，而不一致时最需要看清的恰是那一刻。',
  'admin.settings.provider': '当前供应商',
  'admin.settings.col.op': '步骤',
  'admin.settings.col.configModel': '部署值',
  'admin.settings.col.override': '覆盖为',
  'admin.settings.col.effective': '实际生效',
  'admin.settings.useDeploy': '（不覆盖，用部署值）',
  'admin.settings.state.default': '用部署值',
  'admin.settings.state.default.hint': '没有设过覆盖，跟随部署配置。',
  'admin.settings.state.override': '覆盖生效中',
  'admin.settings.state.override.hint': '你设的覆盖正在被使用。重新部署不会抹掉它。',
  'admin.settings.state.ignored': '覆盖被忽略',
  'admin.settings.state.ignored.hint': '覆盖存着，但那个型号已不在本环境的可路由集合里，于是系统静静回退到了部署值。改选一个当前可用的型号，或撤销覆盖。',
  'admin.settings.src.discovered': '拉取发现',
  'admin.settings.why.noVision': '无视觉能力',
  'admin.settings.why.unknown': '能力未知',
  'admin.settings.catalog.fresh': '型号目录：新鲜',
  'admin.settings.catalog.stale': '型号目录：已超过一天没刷新',
  'admin.settings.catalog.never': '型号目录：尚未拉取（mock 姿态或刚部署）',
  'admin.settings.catalog.count': '共 {n} 个可选型号',
  'admin.settings.spend.title': 'LLM 花费（最近 30 天）',
  'admin.settings.spend.intro': '按供应商回报的输入／输出 token 与本部署配置的每百万单价，在读取时计价。这不是账单——缓存折扣、推理 token 等不在其中；没配价目、或没回用量的调用只计次数不计价，并单独列出。',
  'admin.settings.spend.absent': '本部署没有接库，花费台账未接线——这里不显示 0，因为「没接线」与「零花费」不是一回事。',
  'admin.settings.spend.pricedOf': '已计价　·　本期共 {n} 次调用',
  'admin.settings.spend.incomplete': '上面这个数不完整：',
  'admin.settings.spend.caveat.unpriced': '另有 {n} 次调用所用的型号没有配价目，只计次数、未计价（常见原因：价目表里的型号名拼错）。',
  'admin.settings.spend.caveat.noUsage': '另有 {n} 次调用没有用量读数（其中 {failed} 次失败——供应商可能已计费），只计次数、未计价。',
  'admin.settings.spend.col.model': '型号',
  'admin.settings.spend.col.calls': '调用',
  'admin.settings.spend.col.priced': '已计价',
  'admin.settings.spend.col.unpriced': '未配价目',
  'admin.settings.spend.col.noUsage': '无用量',
  'admin.settings.saved': '已保存并即刻生效',
  'admin.settings.cleared': '已撤销覆盖，回到部署值',
  'admin.settings.error': '保存失败，请稍后重试。',
  'admin.settings.authorityNote': '本页只改得动**模型选择**。管理员名单、职位权限、不可逆闩锁一律以部署期配置为准，在这里改不动，也不该在这里改（OQ-B28 二期分键裁定）。',
  'admin.settings.op.ticket_review': '工单预读（agent 出题）',
  'admin.settings.op.translate': '工单自动翻译',
  'admin.settings.op.polish': 'AI 润色',
  'admin.settings.op.asset_review': '素材视觉判读',
  'admin.settings.op.chat': '对话（冒烟路由）',
  'nav.adminSettings': '服务设置',
  'approvals.title': '审批浏览',
  // 第六十八批改：这行从第六十六批起就是**假的**——L3 已经把受理/驳回/请补 + 批注
  // + 作答做进页面了，而横幅仍在说"裁决动作仍经工作空间通道执行"。界面为**不存在的
  // 缺席**背书，与 DP-6 同型、方向相反：它劝人别用一个已经能用的东西。
  'approvals.readonlyNote': '可在此裁决：展开任一工单，答完 agent 预读的问题（若有），选受理／驳回／请求补充并写批注，一次提交即完成拉取、转态与台账记录。工作空间通道仍然可用，但不再是唯一入口。',
  'approvals.error': '审批列表加载失败',
  'approvals.empty': '暂无工单',
  'approvals.emptyFiltered': '当前过滤条件下没有工单',
  'approvals.filter.type': '类型',
  'approvals.col.submitter': '提交人',
  'approvals.author.submitter': '提交人',
  'approvals.author.handler': '处理方',
  'approvals.detail.submitter': '提交人',
  'approvals.detail.target': '目标文档',
  'tickets.detail.resubmit.title': '补充信息并重新提交',
  'tickets.detail.resubmit.label': '补充说明（可选）',
  'tickets.detail.resubmit.action': '重新提交',
  'tickets.detail.resubmit.done': '已重新提交，工单回到待处理队列。',
  'tickets.detail.withdraw.action': '撤回工单',
  'tickets.detail.withdraw.title': '撤回该工单？',
  'tickets.detail.withdraw.desc': '撤回是终止操作，不可恢复：工单就此结案，工单号作废，请补信息的对话线索和已上传的附件都不再继续。如果只是想补材料，请关闭本框，在上方「补传附件」里上传后点「重新提交」——不需要撤回重交。',
  'tickets.detail.attach.title': '补传附件',
  // 第三百六十二批：补上指派单那一格（attachment_window_open 的第三个子句）。
  'tickets.detail.attach.helper': '工单在「待处理」或「请补充信息」期间都可以补传附件，不必撤回重交；指派单则只有发出方能补传，且只到受指派人首次作答之前。',
  'tickets.detail.attach.action': '上传附件',
  // 折叠行上的提示：挑好还没传的文件现在存在页面上，折叠也不会丢——但必须让人看见它还在，
  // 否则"我明明挑了文件"和"界面上什么都没有"之间又只剩猜。
  'tickets.detail.attach.pending': '{n} 个附件已挑选、尚未上传',
  'tickets.detail.attach.hold': '有附件没有上传成功，重新提交已暂缓。请重试上传或移除失败的文件后再提交。',
  'tickets.detail.withdraw.confirm': '确认撤回',
  'tickets.detail.withdraw.done': '已撤回。',
  // ── SB-190 §8（第二百四十五批）：指派单的两个动作与两枚标签 ──────────────
  // respond 只给受指派人（可多次，成一条反馈线程）；close 只给发出方／审批人／管理员——
  // P1：责任方永远不该控制量它的那把尺子，所以受指派人的详情面根本没有关闭按钮。
  'tickets.detail.author.assignee': '受指派人',
  // 受指派人看线程时，发出方那一侧的反馈行（含 A2 的关闭说明）标它，不标「我」。
  'tickets.detail.author.issuer': '发出方',
  'tickets.roleResponder': '指派给我',
  'tickets.detail.respond.title': '响应这张指派单',
  'tickets.detail.respond.label': '响应内容',
  'tickets.detail.respond.action': '提交响应',
  'tickets.detail.respond.done': '已响应。可以继续补充，每次响应都会记入线程。',
  'tickets.detail.close.title': '关闭该指派单？',
  'tickets.detail.close.desc': '关闭是这类工单唯一的出口，不可恢复：受指派人之后不能再响应。如果还想追问，请另开一张指派单并在「派生自」填本单编号。',
  'tickets.detail.close.noteLabel': '关闭说明（可选）',
  'tickets.detail.close.action': '关闭指派单',
  'tickets.detail.close.confirm': '确认关闭',
  'tickets.detail.close.done': '已关闭。',
  // SB-190 步 5：详情头的「派生自」芯片——derivedFromNo 自第二百四十五批起就在详情 JSON 上，
  // 此前无处渲染（P3：原单不动，芯片只是指回去）。
  'tickets.detail.derivedFrom': '派生自 {no}',
  'app.langToggle.aria': '切换语言',
  'lang.zh': '中文',
  'lang.en': 'English',
  'ticketOp.archive': '已归档',
  'ticketOp.unarchive': '取消归档',
  'ticketNote.auto': '自动',
  'ticketNote.timeoutRequeue': '超时回退（§5.2）',
  'work.hoursValue': '{n} 小时',
  'workItems.untranslated': '原文 {lang}',
  'rule.R-01': '所选日期在可录入窗口之外（仅限今天前后数天）。',
  'rule.R-04': '该工单已处于终态（或已合并），不能再登记工时。',
  'rule.R-05': '时长必须是 0.5 小时的正整数倍。',
  // 第八十四批：网关的三种拒绝各有错误码（见 WorkHoursPage 的 workErrText），
  // 这一条兜住 store 直接抛出的 R-08 报文——不让英文原文漏到界面上。
  'rule.R-08': '规划工时只有本人、且只在当天到来之前可以改或删。',
  'rule.R-11': '当日全部工单合计将超过 16 小时上限（含规划中）。',
  'rule.R-29': '摩擦内建单不接受直接录入工时。',
  'rule.R-36': '冲正不符合规则：只能由本人对已投入的原始记录冲正，且不超过原时长。',
  'submit.field.relatedBacklog.groupMine': '与我相关',
  'submit.field.relatedBacklog.groupOther': '其他工单',
  'docs.stubBadge': '待撰写',
  'notif.aria': '通知',
  'notif.aria.count': '通知，{n} 条未读',
  'notif.label': '通知',
  'notif.error': '通知加载失败，请稍后重试。',
  'notif.title': '通知',
  'notif.readAll': '全部已读',
  'notif.empty': '暂无通知。',
  'notif.ticket_accepted': '你的工单 {no} 已受理',
  'notif.ticket_rejected': '你的工单 {no} 被驳回',
  'notif.ticket_info_requested': '工单 {no} 需要你补充信息',
  'notif.ticket_auto_withdrawn': '工单 {no} 因超时未补充已自动撤回',
  'notif.ticket_published': '你的工单 {no} 已随发布正式结案',
  'notif.incident_confirmed': '你上报的事故 {no} 已确认',
  'notif.backlog_stakeholder_linked': '你已被设为工作项 {no} 的关联方',
  'notif.backlog_stakeholder_unlinked': '你已被解除工作项 {no} 的关联',
  'notif.backlog_cancelled': '工作项 {no} 已被级联取消',
  // SB-083（第六十八批）：工作项的**要求**变了。note 里带一句撰写者写的说明。
  'notif.backlog_requirements_changed': '工作项 {no} 的要求有变更',
  // SB-052（2026-08-17）工单侧三产者：T0 给审批人、T6 给管理员（工作空间操作员的
  // 承载，取舍见 SB-052）、I3 给提交人。
  'notif.ticket_submitted': '新工单 {no} 已提交，等待受理',
  'notif.ticket_requeued': '工单 {no} 处理超时，已重回待审队列',
  // 第二百三十一批：这一条**不是**关于某张工单的，是关于整台机器的——模型服务的
  // 账户不让用之后，此后每一条 AI 作业都会失败。措辞要让人一眼看出该去做什么。
  'notif.provider_blocked': '模型服务的账户此刻不让用（余额、配额或密钥），AI 作业正在全部失败——账户恢复后到作业面板重排它们',
  'notif.incident_reviewed': '你上报的事故 {no} 已复盘结案',
  // SB-190 §3.1（第二百四十五批）：A 机三产者——A0 给受指派人、A1 给发出方、A2 给受指派人。
  // 铃铛默认把 entityKind:'ticket' 送到 /my-tickets（notifTarget.mjs），三条都落在那一页。
  'notif.ticket_assigned': '工单 {no} 指派给你，等待你的响应',
  'notif.ticket_responded': '指派单 {no} 有了新的响应',
  'notif.ticket_closed': '指派单 {no} 已关闭',
  'workItems.title': '工作项',
  'workItems.subtitle': '项目组当前处于待办/进行中的工作项（BL-）。点开条目可查看详细说明。',
  'workItems.onlyMine': '只看与我相关',
  'workItems.mineChip': '与我相关',
  'workItems.empty': '当前没有处于活动状态的工作项。',
  'workItems.emptyFiltered': '没有与你相关的工作项。',
  'workItems.error': '加载工作项失败。',
  'workItems.noGroup': '当前账号没有可用的项目组。',
  'workItems.status.pending': '待办',
  'workItems.status.in_progress': '进行中',

  // ── 第一百零二批（SB-106）：项目汇报读面 ──
  'reports.title': '项目汇报',
  'reports.subtitle': '当前项目组的汇报文档。由项目侧经 CLI 写入并留痕，本页只读。',
  'reports.noGroup': '当前账号没有可用的项目组。',
  'reports.empty': '这个项目组还没有汇报。',
  'reports.error': '加载汇报清单失败。',
  'reports.detailError': '加载这篇汇报失败。',
  'reports.gone': '这篇汇报已不存在（可能刚被改名或删除）。',
  'reports.selectHint': '从左侧选择一篇汇报。',
  'reports.revision': '第 {n} 版',
  'reports.updated': '更新于 {time}',
  'reports.revisions': '最近修订',
  'reports.revisionsEmpty': '暂无修订记录。',
  // 第三百零九批（SB-202 S3 余项）：按 key 前缀分标签看清单（进度报告一族最近在前）
  'reports.tag.all': '全部',
  'reports.tag.other': '其它',
  // 第一百零四批：agent 徽标收成共享件（components/AgentChip.jsx），键随之出
  // reports 命名空间——组间通信的消息流用的是同一枚徽标、同一句提示。
  'agent.badge': 'Agent',
  'agent.badgeHint': '这一条由 agent 凭 API key 写入（主体由凭据推导，不可自称）。',

  // ── 第一百零二批：成员×组编辑（管理页） ──
  'admin.accounts.groups': '项目组',
  'admin.accounts.groups.none': '未加入任何组',
  'admin.accounts.groups.edit': '编辑',
  'admin.accounts.groups.title': '设置 {email} 的项目组',
  // 这段文案落在普通 Typography 里（不过 MarkdownBody），所以不写 ** 之类的记号——
  // 那会原样印成星号。
  'admin.accounts.groups.hint': '勾选的这一组就是该账号往后的全部项目组：保存为替换，未勾选的即被移除。全部不勾也是合法的——那表示该账号不属于任何项目组。',
  'admin.accounts.groups.adminNote': '管理员本就对全部项目组可见，这里的成员关系不改变可见性，只决定它属于哪个组。',
  'admin.accounts.groups.dropped': '该账号还挂在已归档或已不存在的项目组上（{list}）。这些组不能再被设置，本次保存会把它们一并移除。',
  'admin.accounts.groups.empty': '系统里还没有项目组。',
  'admin.accounts.groups.saved': '项目组已更新。',

  // ── 第一百零四批 B：组间通信 ──
  'shell.nav.threads': '组间通信',
  'threads.title': '组间通信',
  // 透明口径（需求方裁）：本页不按当前组过滤，执行层全员全量可读——页头这一句就是
  // 那条裁决的落点，删了它用户会以为"看得见别组的线"是一个漏洞。
  // 第一百零八批 C1：措辞由"全员"收成"执行团队全员"。这不是文案润色——读到这一句
  // 的人正在决定"我在这里说的话有谁会看见"，而那句话的答案本批变了。
  'threads.subtitle': '项目组之间的通信线，执行团队全员可读、不按当前组过滤；一条线可以有多个参与组，发起与回复仅限联络人，消息以组的名义发出。',
  // 非执行层（外包/外部顾问＝合同相对方；资方＝所有者）落地的那一句。
  // **说得出理由**：只写"无权访问"会让人以为是配置错了而去开工单；写清"这个面本就
  // 不面向你、你要的东西在别处"，他才知道下一步该往哪走。
  //
  // ── 第一百零八批 R1（B5）：第三类读者 ────────────────────────────────────────
  // 这一句原本只写给那两类人，但**落到它上面的还有第三类**：内部工程师的
  // `job_post_key` 与 config 漂开时（职位改名、某个 stage 的镜像漏了一岗、键拼错），
  // 后端 `party_of` 查无此职、返回空串 ⇒ 非内部 ⇒ 他看到的是同一句话。于是这句话
  // 对他说的是"你是外部合作方或者资方"——一个**假理由**，而它比"无权访问"更坏：
  // 前者只是没解释，后者给了一个错的解释，他会照着这个解释去做错的事（去开合同侧的
  // 工单、或者干脆认为自己被降权了）。
  // 所以补一条出路，且它必须**说得出机制**："这是配置问题"要指出配置的哪一处，
  // 否则和"请联系管理员"是同一句空话——那句话不告诉人为什么、也不告诉人说什么。
  'threads.noAccess': '组间通信是执行团队内部的工作面，当前账号不在其中，因此看不到这些线。'
    + '外部合作方请走工单与合同通道；资方请看项目汇报与审批面——那里是经过整理的结论。'
    + '如果你本就在交付团队里，那多半不是一条针对你的裁决，而是一处配置漂移：'
    + '你的职位没有声明自己属于执行团队，或者这个环境的职位表漏了这一岗（职位改名、'
    + '键拼错都会这样）。把你的邮箱与职位名告诉我们即可——这是改一行配置的事，'
    + '不用重新申请权限。',
  'threads.empty': '还没有任何组间通信线。',
  'threads.error': '加载线列表失败。',
  'threads.detailError': '加载这条线失败。',
  'threads.gone': '这条线已不存在（可能刚被删除）。',
  'threads.selectHint': '从左侧选择一条线。',
  'threads.messages': '{n} 条消息',
  'threads.noMessages': '这条线还没有消息。',
  'threads.status.open': '进行中',
  'threads.status.closed': '已关闭',
  'threads.asGroupHint': '这条消息以该组的名义发出。',
  'threads.partiesInferred': '参与组待补',
  'threads.partiesInferredHint': '这条线的参与组是按发起两方推得的（服务端没有给出参与组集合）。'
    + '若服务端已是当前版本，多半是参与集回填漏了这条线——请报给运维；在补上之前，'
    + '这条线上的第三方无法代表自己的组发言。',
  'threads.new': '发起新线',
  'threads.reply': '回复',
  'threads.replyAs': '代表组',
  'threads.notAParty': '你不是这条线任何参与组的成员，不能在此线代表发言（读没有限制）。',
  'threads.replyBody': '回复内容',
  'threads.replied': '回复已发送。',
  // 裁决④：待归档的线上发一句话＝自动取消那次归档。不说出来的话，用户既不知道
  // 自己撤了别人的提议，也无从判断那枚忽然消失的「待归档」徽标是不是个 bug。
  'threads.repliedArchiveCancelled': '回复已发送——你这条回复同时取消了这条线的归档提议（发言＝业务未毕）。',
  'threads.replyError': '回复失败。',
  'threads.closedError': '这条线已关闭，不再接受新消息。',
  'threads.forbidden': '当前账号没有组间通信的写入权限（联络人限定）。',
  'threads.form.subject': '主题',
  'threads.form.from': '发起组',
  'threads.form.to': '对象组（可多选）',
  'threads.invite': '拉进来',
  'threads.inviteLabel': '追加参与组',
  'threads.inviteHint': '被加入的组从此可以在这条线里代表发言；读面本就对全员开放。',
  'threads.invited': '该组已加入这条线。',
  'threads.inviteNoop': '该组已经在这条线里了，没有变化。',
  'threads.inviteError': '追加参与组失败。',
  'threads.form.body': '正文',
  'threads.form.create': '创建',
  'threads.form.needSubject': '还差：主题。',
  'threads.form.needFrom': '还差：发起组。',
  'threads.form.needTo': '还差：至少一个对象组。',
  'threads.form.sameGroup': '发起组不能同时出现在对象组里。',
  'threads.form.needBody': '还差：正文。',
  'threads.created': '新线已创建。',
  'threads.createError': '创建失败。',

  // ── 归档 + 三日否决窗口（第一百二十五批 C，需求方 2026-08-20 三裁）────────────
  // 「待归档」的措辞是**载重**的，不是文案：读到它的人正在决定要不要出声，而
  // 这是本系统里唯一一处"不作声就算同意"。所以徽标不只说状态，还给出到期时刻。
  'threads.archive.state.archive_pending': '待归档',
  'threads.archive.state.archived': '已归档',
  'threads.archive.dueAt': '{at} 自动归档',
  'threads.archive.dueNever': '不会自动归档（窗口已关）',
  'threads.archive.autoMark': '自动归档',
  'threads.archive.request': '提议归档',
  'threads.archive.cancel': '取消归档',
  'threads.archive.reopen': '重开',
  'threads.archive.showArchived': '显示已归档',
  'threads.archive.pendingHint': '任意参与方都可以取消；在线里说一句话也会自动取消（业务未毕）。',
  'threads.archive.archivedHint': '已归档：只读、默认不在列表里。重开之后可以接着说。',
  // ⚠ 窗口长度是**服务端配置**（sweep.threadArchiveVetoDays）：把「三日」写进文案，
  // 那一行在配置改成 7 的当天就成了假话，而且没有任何东西会响。所以这一族一律说
  // **时刻**（服务端算好随行给的 archiveDueAtMs），不说天数——dueAt 早就这么做了，
  // 这里照抄。判据在 pages/threads.test.mjs（threads.archive.* 与 notif.thread_archive_*
  // 全族不许出现手写数字）。
  'threads.archive.requested': '已提议归档：无人取消的话，这条线会在 {at} 自动归档。',
  // 窗口被关掉（后端给 archiveDueAtMs=null）：它**不会**自己完成——与上一句差的是
  // 一次否决权，不能都说成"已提议归档"。
  'threads.archive.requestedNever': '已提议归档。自动归档窗口已关，所以它不会自己完成。',
  // 确认框正文：人还没点，只许说**将来时**（上一句是完成时，摆在确认框里等于
  // 界面先替他把事办了）。这里唯一值得说的信息是**沉默的后果**。
  'threads.archive.confirmBody': '这不是立刻归档：它开一个否决窗口，窗口内任意参与方都可以取消，'
    + '在线里回一句话也会取消（发言＝业务未毕）。到期无人出声，这条线就会自动归档'
    + '——沉默在这里等于同意，而每个参与组的联络人都会为此收到一条提醒。',
  'threads.archive.cancelled': '归档已取消。',
  'threads.archive.reopened': '这条线已重开。',
  'threads.archive.requestError': '提议归档失败。',
  'threads.archive.cancelError': '取消归档失败。',
  'threads.archive.reopenError': '重开失败。',
  // 四种 409 各说各的下一步（后端逐个分了码，前端不该把它们压成一句"再试一次"）。
  'threads.archive.vetoedError': '这条线的归档提议曾被取消过，所以沉默不再等于同意——它不会再被归档。'
    + '有异议就在线里谈；这件事真的完了，就另开一条线谈下一件。',
  'threads.archive.pendingError': '已经有人提议归档了：等它到期，或直接取消。',
  'threads.archive.archivedError': '这条线已经归档了。要接着说先重开。',
  'threads.archive.nonePendingError': '这条线上没有待取消的归档提议。',
  'threads.archive.notArchivedError': '这条线没有归档，无从重开。',

  // ── 第一百零九批 D：站内信 / 密件取件 / CLI 下载 ────────────────────────────
  // 键位逐条来自本批契约 D 节，**不许自造**。三族动态键（dm.state.* / dm.anchor.* /
  // dm.failReason.*）在 pages/messages.mjs 里有一张显式字面量映射表并配单测——
  // keys.test.mjs 扫的是源码里的 t('字面量')，`t(\`dm.state.${s}\`)` 它看不见，
  // 第五十四批 COMMON.CLOSE 那次付过这笔账。
  'shell.nav.messages': '站内信',
  'shell.nav.secrets': '密件',

  // 站内信 · 列表面
  'dm.title': '站内信',
  'dm.subtitle': '一对一的信。发送必须说明这封信关于什么；提醒最长约一分钟才出现。',
  'dm.tab.inbox': '收件箱',
  'dm.tab.outbox': '发件箱',
  'dm.empty.inbox': '没有收到过站内信。',
  'dm.empty.outbox': '没有发出过站内信。',
  // 第一百二十五批「已回复」：「只看未回复」把清单滤空时说这一句。与上面两句**分开**：说"没有收到过
  // 站内信"会让人以为信丢了，而真相是"都回过了"——一句他手上正好有开关能推翻的假话。
  'dm.loadMore': '加载更多',
  'dm.loadMoreBusy': '正在取…',
  'dm.loadMoreError': '这一页没取回来——不是没有了，是没取到。再试一次。',
  'dm.empty.unreplied': '这个箱子里的信都已经有回复了。',
  // 取满一页时**不敢**说整箱（unrepliedEmptyKey）：这一页只有 DM_PAGE_LIMIT 行，
  // 滤的是这一页、断言的是整箱——收件箱超过一页时上面那句就是确定的假话。
  'dm.empty.unrepliedPage': '这一页的信都已经有回复了；这个箱子里的信不止这一页，更早的看不到。',
  'dm.error.list': '站内信列表加载失败。',
  'dm.error.detail': '这封信加载失败。',
  'dm.col.counterpart': '对方',
  'dm.col.anchor': '关于',
  'dm.col.state': '状态',
  'dm.col.time': '时间',
  'dm.dir.in': '来自 {who}',
  'dm.dir.out': '发给 {who}',
  'dm.state.queued': '排队中',
  'dm.state.sent_unread': '已发出·未读',
  'dm.state.read': '已读',
  'dm.state.withdrawn': '已撤回',
  'dm.state.failed': '未能发出',
  'dm.anchor.same_group': '同组：{ref}',
  'dm.anchor.work_item': '工作项 {ref}',
  'dm.anchor.doc': '文档 {ref}',
  // 方向中性措辞（SB-150 证伪评审）：这句在发件箱行、引用链每一层都会出现，链上
  // 作者逐层交替，「回复你…的来信」那个"你"隔层必然指错人——时刻已足够定位。
  'dm.anchor.reply': '回复 {ref} 发出的那封信',
  'dm.anchor.strong': '你是这项的干系人',
  'dm.willSend.at': '预计 {t} 发出',
  'dm.willSend.blocked': '等对方读完你上一封才会发出',
  'dm.failReason.wait_expired': '对方三天内没有读你上一封，这封没有发出。',
  'dm.failReason.worker_gave_up': '系统多次尝试后未能发出这封信，请重写一封。',
  'dm.exposed.in': '这封信在 {t} 就写好了，因为你还没读上一封而排到了现在。',
  'dm.exposed.out': '这封信 {t} 排队，等到对方读了上一封才发出——他看得见这一点。',
  'dm.unread.badge': '{n} 封未读',
  // SB-148 B：系统信（管理员经审过的模板发送）。收件人要一眼分辨"这不是某个人手写的"。
  'dm.system.chip': '系统信',
  // SB-190 §3.3（第二百四十五批）：「要求响应」徽标。收发两侧、列表／详情／强制阅读闸三个读面
  // 同一枚——收件人必须知道自己头上有一只钟，发送方必须知道对方看得见这一点。
  'dm.responseRequired.chip': '要求响应',
  // 第一百二十五批：「已回复」。它与状态徽标**并排**，不替换它——原状态仍然是"已读"，而
  //「他读了没回」正是这一格要答的那句话。收发两侧同一句：收件箱＝我回过，发件箱＝他回过。
  'dm.replied.chip': '已回复',
  'dm.replied.at': '{t} 回复',
  'dm.filter.unreplied': '只看未回复',

  // 站内信 · 读一封
  'dm.read.open': '打开正文',
  'dm.read.confirmTitle': '打开就算已读',
  'dm.read.confirmBody': '点开正文的那一刻这封信就算已读：对方会收到已读提醒，并且再也不能撤回它。',
  'dm.read.confirmOk': '打开',
  'dm.read.gone': '发送方在你打开之前撤回了这封信，正文已经不存在——系统没有留副本。要紧的话去问他。',
  'dm.read.goneMine': '你撤回了这封信，系统清掉了正文——留副本的撤回不算撤回。',
  'dm.read.notFound': '没有这封信。',
  'dm.read.readAt': '对方 {t} 读了这封信',

  // 站内信 · 写信
  'dm.new.title': '写站内信',
  'dm.new.to': '收件人',
  'dm.new.toHelper': '从下拉里挑人（输入即过滤）；不在名单里的人，直接填邮箱也行。',
  'dm.new.toGroupSame': '与我同组',
  'dm.new.toGroupHistory': '曾给我写过信',
  'dm.new.anchor': '这封信关于什么',
  'dm.new.anchorHelper': '收件人要看得见你凭什么给他写信：同一个组、某个工作项、某份文档，或者他之前发给你的信。',
  'dm.new.anchorLoading': '正在找你们的共同引用…',
  'dm.new.anchorEmpty': '你们之间没有共同的引用，所以这封信发不出去。',
  'dm.new.anchorTruncated': '还有更多候选未列出：先缩小范围再挑。',
  'dm.new.anchorSearch': '挑一个共同引用（输入即过滤）',
  'dm.new.body': '正文',
  'dm.new.bodyFormat': '正文格式',
  'dm.new.schedule': '延迟发送',
  'dm.new.scheduleHelper': '最多 72 小时以内。留空即尽快发出。',
  'dm.new.blocked': '对方还没读你上一封信，所以这封只能排队——等他读了就会自动发出。',
  'dm.new.blockedWindow': '三天内他仍未读，这封信就不会发出，你会收到提醒。',
  'dm.new.pending': '你已经有一封发给他的信在排队（#{id}）。一次一封：撤回它，或者等它发出。',
  'dm.new.send': '发送',
  'dm.new.sent': '已排队。',
  'dm.new.sentNow': '已发出。',
  'dm.new.needTo': '还差：收件人。',
  'dm.new.needAnchor': '还差：这封信关于什么。',
  'dm.new.needBody': '还差：正文。',
  'dm.new.tooLong': '正文 {n} 字，上限 20000 字——长文请写成工作项，再用它作锚点。',
  'dm.new.error': '发送失败。',
  'dm.new.recipientInactive': '这个账号已停用——发给他的信永远不会被读到。换一个收件人。',
  // SB-190 §3.3：编写器上的标记位。发出时即定、事后不可补——这是「标记事后不补」在站内信
  // 通道的落点，话术要把"之后没法加"说在前面。
  'dm.new.responseRequired': '要求响应',
  'dm.new.responseRequiredHelper': '勾上即表示这封信要对方作答，对方会看到「要求响应」徽标。发出时即定，之后不能再补标。',

  // 站内信 · 撤回
  'dm.withdraw.action': '撤回',
  'dm.withdraw.title': '撤回这封信',
  // 两句话，按状态分岔（withdrawDescKey）。**给两种后果同一句话就是承诺一个做不到的
  // 撤回**：已发出的那一封，收件箱里那一行原地留着（撤回只清正文），他照样看得见
  // 「来自 张三 · 关于 … · 已撤回」，点开还会拿到一句'发送方在你打开之前撤回了这封信'。
  'dm.withdraw.descQueued': '这封信还没发出去，撤回之后对方不会知道它存在过：正文会被清掉，系统不留副本。',
  'dm.withdraw.descSent': '这封信已经送到他的收件箱了，只是他还没点开。撤回会清掉正文、系统不留副本，但**他仍然会看到一条“已撤回”的记录**（来自谁、关于什么、什么时候），点开时会被告知你在他打开之前收回了它。',
  'dm.withdraw.ok': '已撤回。',
  'dm.withdraw.tooLate': '来不及了——对方 {t} 打开了它。撤回只在对方读到之前有效。',
  'dm.withdraw.already': '这封信 {t} 就已经撤回过了。',
  'dm.withdraw.failed': '这封信本来就没有发出去（{t} 失败），没有什么可撤回的。',
  'dm.withdraw.error': '撤回失败。',

  // 站内信 · 举报窄通道（第一百零九批 P1 ②，需求方裁）
  // 默认仍是「管理员读不到别人的站内信」；这里是收件人**自己**按下的那一条窄缝。
  // 三句话必须在**点之前**说完（不可撤销 / 只有这一封 / 对方不会被告知），
  // 而"对方不会被告知"这一句尤其不能事后补：一个以为对方会知道的人会因为怕撕破脸
  // 而不点，一个以为对方不会知道的人如果实际上会被通知，那是把他推进了他没同意的处境。
  'dm.report.action': '交给管理员',
  'dm.report.title': '把这封信交给管理员',
  'dm.report.confirmBody': '管理员将能读到**这一封**的正文，以及它是谁在什么时候发给你的。他读不到你们之间的其它信——交出去的只有这一封。',
  'dm.report.irreversible': '交出之后收不回来。这一点没有例外：一个能收回的“交出”只是一个可以反复试探的开关。',
  'dm.report.noNotice': '对方不会收到任何通知。这不是偷偷进行——举报的意义是让第三方介入，而先通知他，等于让他在有人介入之前先做反应。',
  'dm.report.confirmOk': '交出这一封',
  'dm.report.ok': '已交给管理员。',
  'dm.report.doneAt': '你在 {t} 把这封信交给了管理员（不可撤回）。',
  'dm.report.error': '交出失败。',

  // 站内信 · SB-150 快捷回复与引用原文。撤回/不可见两句是**诚实的终态**（不给重试）：
  // 410=撤回把正文物理清空了，404=隐匿闸的原话——两句都不是故障。
  'dm.reply.action': '回复',
  'dm.reply.lockedHelper': '回复对方来信——收件人与「关于」已自动带上，不可修改。',
  'dm.quote.expand': '展开引用原文',
  'dm.quote.collapse': '收起',
  'dm.quote.withdrawn': '原文已被发送方撤回。',
  'dm.quote.notFound': '原文不可见。',
  'dm.quote.error': '原文加载失败。',

  // 站内信 · alert（铃铛是 60 秒轮询，没有推送——文案不许承诺即时）
  'notif.dm_received': '有人给你发了站内信',
  'notif.dm_read': '对方读了你的站内信',
  'notif.dm_wait_expired': '一封排队的站内信没能发出',

  // 组间线归档四事（第一百二十五批 C）。{no} 是线 id。
  // 「待归档」那条要说出**沉默的后果**：这是本系统里唯一一处"不作声就算同意"，
  // 一句只说"有人发起了归档"的提醒会被当成告知而不是需要回应的事。
  // 到期时刻在**线上**那枚徽标里（通知行只带 kind/entityNo，没有时间戳可插）；
  // 这里就不许写死天数——窗口长度是服务端配置，写死的那天数迟早成假话。
  'notif.thread_archive_requested': '有人提议归档组间线 #{no}——到期无人取消即自动归档（到期时刻见线上的「待归档」徽标）',
  'notif.thread_archive_cancelled': '组间线 #{no} 的归档提议已取消',
  'notif.thread_archived': '组间线 #{no} 已归档（可随时重开）',
  'notif.thread_reopened': '组间线 #{no} 已重开',

  // 站内信 · 强读闸（SB-146，第一百二十二批；2026-08-20 裁：自动标已读改手动确认）。
  // why 那句要把「为什么被拦」说清：第一次撞上全屏遮罩的人不该以为页面坏了。
  // 秒数一律用 {s} 占位、由 READ_COUNTDOWN_SECONDS 插值——手写的数字会在常量改动
  // 的那天变成假话（判据在 forcedReadQueue.test.mjs 咬着）。
  'forcedRead.title': '有必须先读完的站内信',
  'forcedRead.why': '你有未读的站内信。为保证送达，系统会在你继续浏览之前带你逐封读完：滚动到正文末尾、等 {s} 秒读秒走完，再点「确认已读」进入下一封；全部读完后自动放行。',
  'forcedRead.progress': '第 {i} / {n} 封（旧的在前）',
  'forcedRead.sentAt': '发出于 {t}',
  'forcedRead.scrollHint': '滚动到正文末尾后开始读秒。',
  'forcedRead.countdown': '还要 {s} 秒…',
  'forcedRead.confirm': '确认已读',
  'forcedRead.checking': '正在确认是否还有未读的信…',
  'forcedRead.peekErr': '正文加载失败——这封不会被跳过，请重试。',
  'forcedRead.readErr': '标记已读失败——这封不会被跳过，请重试。',

  // 直登清欠链（SB-146 裁决 4）。reason/why 两句必须解释**为什么页面会自己跳**。
  'cleanup.title': '正在清完未读通知',
  'cleanup.reason': '您由邮件直登，系统正带您逐条清完未读通知（第 {i}/{n} 条）。',
  'cleanup.why': '邮件里的直登链接只带你看一页，看完就走的话，其余通知会永远停在未读。所以系统把每一条未读通知逐条带到你眼前：页面会自己跳转，这不是出错。看完这一页想去别处时，它会先带你去下一条。',
  'cleanup.ok': '知道了',
  'cleanup.markErr': '这条通知标记已读失败——请重试，否则无法继续。',
  'cleanup.deferNote': '已连续多次标记失败。你可以暂缓本次清欠：欠账会原样保留在服务端，下次直登或刷新时继续。',
  'cleanup.deferBtn': '暂缓清欠（欠账保留）',
  'cleanup.done.title': '未读已全部清完',
  'cleanup.done.body': '全部未读通知都已看过并标为已读，现在恢复自由浏览。',

  // 错误码 → 人话（errText 的 byCode 表）
  'dm.err.anchorRequired': '这封信必须说明关于什么。',
  'dm.err.anchorKind': '锚点类型不认识——请从列表里选一个。',
  'dm.err.anchorNotShared': '对方看不见你选的这个锚点，换一个他能打开的。',
  'dm.err.alreadyQueued': '你已经有一封发给他的信在排队。一次一封。',
  'dm.err.alreadyRead': '对方已经读了这封信，撤不回来了。',
  'dm.err.alreadyWithdrawn': '这封信已经撤回过了。',
  'dm.err.alreadyFailed': '这封信没有发出去，没有什么可撤回的。',
  'dm.err.goneWithdrawn': '这封信已被撤回，正文不存在了。',
  'dm.err.recipientInactive': '这个账号已停用——发给他的信永远不会被读到。',
  'dm.err.subresourceBlocked': '这个动作要从页面上的按钮点，不能由页面自己发起——它会改变状态（取件即焚 / 点开即已读）。',
  'dm.err.notRead': '先打开这封信再交出去——你交出的是它的正文，而在你打开之前发送方还能撤回它（撤回会清掉正文）。',
  'dm.err.alreadyReported': '你已经把这封信交给管理员了，而交出不可撤回——这里没有别的事可做了。',
  'secrets.err.goneTaken': '这是一次性密件，已经被取走，正文永久消失。如果不是你取的，那枚凭据已经外泄：去轮换它，不要请人重发。',
  'secrets.err.goneExpired': '这件密件的有效期已过，请签发方重发一件。',
  'secrets.err.goneRevoked': '这件密件被签发方或管理员吊销了，问清原因再要。',
  'secrets.err.issuerCannotTake': '你是签发方。取件是收件方的动作，一次性密件会在这里被烧掉。',
  'secrets.err.alreadyRevoked': '这件密件已经被吊销过了。',
  'cli.err.distAbsent': '这个部署里没有带 CLI 分发包，这是部署侧的问题，不是你点错了。',

  // 密递取件面
  'secrets.title': '密件',
  // ⚠ 「每一件都指名收件人」只对**新签发**的成立（第一百零八批 C3 起 toAccount 必填）。
  // 存量的组粒度行（to_account_id IS NULL）组里每个人都取得走，而 addressedToMe 对它们
  // 一律回 true ⇒ 每个人都看到取件按钮。文案先不撒谎；那批存量行的处置见 SB-122。
  'secrets.subtitle': '点对点递交的凭据。新签发的每一件都指名收件人；一次性密件取走即焚。少数早期的密件是签给整个组的，组里任何人都能取走——取之前先确认那一件是不是给你的。',
  'secrets.empty': '没有与你有关的密件。',
  'secrets.error': '密件列表加载失败。',
  'secrets.col.label': '标题',
  'secrets.col.from': '来自',
  'secrets.col.to': '给',
  'secrets.col.mode': '类型',
  'secrets.col.state': '状态',
  'secrets.col.created': '签发时间',
  'secrets.mode.once': '一次性',
  'secrets.mode.ttl': '限时',
  'secrets.mode.onceTtl': '一次性 · {t} 前有效',
  'secrets.state.available': '可取',
  'secrets.state.taken': '已取走',
  'secrets.state.expired': '已过期',
  'secrets.state.revoked': '已吊销',
  'secrets.take': '取出正文',
  'secrets.take.confirmTitleOnce': '取出就烧掉',
  // 限时件**不焚**（store 只在 mode=='once' 时清空正文）。此前两种件共用上面那一句
  // 标题，于是对话框标题说“取出就烧掉”、正文说“到期之前可以反复取出”，自相矛盾；
  // 而一句会被当场证伪的警告，会训练人不信那个标题——下次真是 once 件时他闭眼点过去。
  'secrets.take.confirmTitleTtl': '取出这一件',
  'secrets.take.confirmBodyOnce': '这是一次性密件：取出正文之后它就永久消失，这个窗口关掉就再也拿不回来。请先准备好粘贴的地方。',
  'secrets.take.confirmBodyTtl': '这件密件在 {t} 之前可以反复取出。',
  'secrets.take.confirmOk': '取出',
  'secrets.body.label': '密件正文',
  'secrets.body.copy': '复制',
  'secrets.body.copied': '已复制。',
  'secrets.body.warning': '这段文字只在这个页面上存在，系统不会再给你第二次。',
  // SB-148 A：第二条本地出口。两个泄漏面各自的风险要在**选之前**说清；
  // 两通道并存，不替用户做选择。
  'secrets.download': '下载为 .txt',
  'secrets.download.note': '复制走剪贴板，下载走磁盘——两条路是两个不同的泄漏面：剪贴板会进剪贴板历史、可能被剪贴板管理器或云同步带到别的设备；文件会留在磁盘上、可能被索引和备份。按你的环境自选一条，用完立刻删掉文件或清掉剪贴板。',
  'secrets.revoke': '吊销',
  'secrets.revoke.desc': '吊销会连正文一起清掉。只有签发方和管理员能做。',
  // ── SB-159（第一百七十八批）：加载更多（与 dm.* 同三句——两面各自成键，
  // 文案将来各按面演化不互相牵）────────────────────────────────────────────
  'secrets.loadMore': '加载更多',
  'secrets.loadMoreBusy': '正在取…',
  'secrets.loadMoreError': '这一页没取回来——不是没有了，是没取到。再试一次。',
  'secrets.revoke.ok': '已吊销。',
  'secrets.mine': '我签发的',

  // CLI 下载页（不进导航；入口从 /help 链过去）
  'cli.title': '命令行工具 dc-cli',
  'cli.subtitle': '下载整包，解压后用你的 API key 配置一次。先在这里拿到工具，再去「密件」里取你的 key。',
  'cli.version': '版本 {v}',
  'cli.bundle.size': '{n} 个文件，{kb} KB',
  'cli.bundle.sha': '整包 SHA-256：{sha}',
  'cli.bundle.shaHint': '下载后可以自己核对这一串，确认拿到的是完整的一份。',
  'cli.download': '下载 zip',
  'cli.requirements': '需要 Node.js 20 或更新版本。',
  'cli.steps.title': '三步',
  'cli.steps.unpack': '1. 解压到任意目录（包内自带一层 dc-cli/ 目录）。',
  'cli.steps.key': '2. 到「密件」页取出管理员发给你的 API key。',
  // ⚠ 包里**没有** dc-cli.jsonc（它带明文 key，被 DIST_DENY_BASENAMES 排除），只有
  // dc-cli.jsonc.example。少了 `init` 这一句，新人解压后照着去找那个文件、找不到，
  // 于是卡在这里来问人——而这一页的全部存在理由就是让他**不用**问人。
  'cli.steps.config': '3. 在解压出来的目录里跑 `node dc-cli.mjs init` 生成 dc-cli.jsonc，把 apiKey 换成刚取到的那枚、把 baseUrl 改成本页的地址，然后 `node dc-cli.mjs describe` 自检。',
  // 裸命令 `dc-cli` 只有自己配了别名之后才存在（包里没有 package.json 的 bin，也没有
  // PATH 上的 shim）。照抄它会得到 command not found，而他会认定“工具装坏了”。
  'cli.selfupdate': '装好之后 `node dc-cli.mjs selfupdate` 会自己跟服务端比对更新，不必再回来下载。（把 `node <路径>/dc-cli.mjs` 起个别名叫 `dc-cli`，文档里的示例就能逐字照抄。）',
  'cli.error': 'CLI 分发信息加载失败。',

  // 管理面 · API key 延迟领取（裁定 1：复用定向密递）
  'admin.apiKey.deliverInstead': '不当时显示，改为密递给他',
  'admin.apiKey.deliverHelper': '勾上以后系统会自动签一件指名给他本人的一次性密件，72 小时内有效。你不会看到明文。过期没取就重签一枚——重签是几秒钟的事。',
  'admin.apiKey.delivered': '已签发，并作为密件 #{id} 递给 {who}，{t} 前有效。',
  'admin.apiKey.deliveredHint': '让他去「密件」页取。取走即焚——他只有一次机会，让他先准备好粘贴的地方。',
  'admin.apiKey.noGroup': '这个账号不属于任何项目组，密件没有落点。先把他加进一个组，或者不勾这一项、自己把 key 交给他。',
  // ── 第二百零七批（SB-180 (e) 实撞）：多组收件人的密件落点组必选，系统不替你猜 ──
  'admin.apiKey.deliverGroup': '密件落点组',
  'admin.apiKey.deliverGroupHint': '密件会落在所选组的密件清单面。该账号属于多个项目组，落点由你选定——系统不替你猜。',
  'admin.apiKey.plaintextWarning': '明文只出现这一次，关掉就再也拿不到。',

  // ══ 第一百一十批 B：agent 能力（三态 / 逃生口 / 再 grill / 工作项草案）══════

  // 契约列了一条 agentReview.status.title，本实现**没有采用**：状态块渲染在
  // AgentReviewPanel 的同一张 Paper 里，而那张 Paper 顶上已经写着 agentReview.title
  //（"AI 预读"）。同一个框里第二条同义的标题是噪音，而一条谁也不用的键会永远躺在
  // 词典里（keys.test.mjs 结构上看不见孤儿键）。
  // A. 预读的状态。此前这三件事在屏幕上逐像素相同，而下一步动作完全不同。
  'agentReview.status.title': '预读状态',
  'agentReview.status.not_applicable': '这类工单本来就不做预读——不是出了问题，也没有什么要等。',
  'agentReview.status.never_queued': 'AI 从未读过这张工单。',
  'agentReview.status.queued': 'AI 预读在队列中，还没轮到它。',
  'agentReview.status.running': 'AI 正在读这张工单。',
  'agentReview.status.failed.transient': 'AI 预读失败（已试 {n} 次）：多半是网络或供应商抖动，重试有意义。',
  'agentReview.status.failed.permanent': 'AI 预读失败：请求本身被拒，再试一次也会被同样拒绝——换个指令再让它读一轮。',
  // 这一条与上一条的处置相同（都不会自动重试），但要人做的事**完全相反**：
  // 上一条要人改指令，这一条要人别改指令。一次实撞里屏幕对着"账户余额不足"说了
  // "换个指令再试"，那是一条做了也没用的建议，而它是当时唯一的提示。
  'agentReview.status.failed.account': 'AI 预读没跑成：不是这张工单的问题，是模型服务的账户此刻不让用（余额、配额或密钥）。指令一个字都不用改——账户恢复之后重排这条作业即可。',
  // 这一条不能省：`result_class` 为空串的存量作业读成 transient，就是对着一条其实是
  // 400 的失败说"多半是网络抖动，重试看看"，而那是三次徒劳重试的邀请。
  'agentReview.status.failed.unknown': 'AI 预读失败，原因不明——这条作业是本批之前排的，没有记录失败分类。',
  'agentReview.status.skipped_quota': '今天的 AI 预读额度用完了，这一张被跳过——不是失败，明天会照常读。',
  'agentReview.status.escalated': 'AI 说它做不了这一件。它自己的理由在下面。',
  'agentReview.status.lastAt': '最近一次：{when}',

  // B. 逃生口在审批面：agent 自己给的理由，比一片空白有用得多。
  'agentReview.blocked.title': 'AI 说它做不了',
  'agentReview.blocked.detail': '它的原话：',
  'agentReview.blocked.wouldNeed': '给它下面这些，它就能做了：',
  'agentReview.blocked.reason.insufficient_context': '材料不够',
  'agentReview.blocked.reason.out_of_scope': '不在它能判断的范围内',
  'agentReview.blocked.reason.contradictory_instructions': '要求前后矛盾',
  'agentReview.blocked.reason.tooling_blocked': '它取不到要看的东西',
  'agentReview.blocked.reason.unsafe_request': '这件事它不该做',

  // C. 人工再 grill。命令是预设的（走 system 轮），自由补充是材料（走 user 轮）。
  'agentReview.rerun.open': '再让 AI 读一轮',
  'agentReview.rerun.title': '再让 AI 读一轮',
  'agentReview.rerun.desc': '重新跑一次预读。可以给它加几条命令，也可以补一段它缺的事实。',
  'agentReview.rerun.warnStale': '重跑会换掉现在这批题：你或别人还没提交的答案会作废（提交时会被拒）。已经记下的裁决不受影响——裁决永不覆盖。',
  'agentReview.rerun.directives': '给它加几条命令（可不选）',
  'agentReview.rerun.directive.draft_work_item': '出一份工作项草案',
  'agentReview.rerun.directive.focus_scope': '重点看范围边界',
  'agentReview.rerun.directive.focus_cost': '重点看成本与工期',
  'agentReview.rerun.directive.focus_risk': '重点看风险',
  'agentReview.rerun.directive.check_duplicate': '查一下是不是重复提交',
  'agentReview.rerun.directive.ask_submitter': '列出该向提交人核实的事实',
  'agentReview.rerun.notePlaceholder': '补一段它缺的事实（选填）。例如：他说的「那台机器」指的是 dev 实例，不是生产。',
  // 这一句是产品面的第一道防线：审批人以为自己在下命令、而那段话其实只是材料时，
  // 他会按一段没有被执行的话去理解结果。
  'agentReview.rerun.noteCaution': '你写的这段是「材料」，不是指令：agent 不会执行里面的要求。',
  'agentReview.rerun.noteCount': '{n} / {max} 字',
  'agentReview.rerun.submit': '重跑一轮',
  'agentReview.rerun.submitting': '排队中…',
  'agentReview.rerun.queued': '已排队：第 {round} 轮。它跑完之前，这一页的内容还是上一轮的，稍后刷新再看。',
  'agentReview.rerun.err.inFlight': '已经有一轮在跑了，等它跑完再说。',
  'agentReview.rerun.err.notReviewable': '这张工单现在不能预读：这类工单不做预读，或者它已经结案了。',
  'agentReview.rerun.err.tooMany': '这张工单今天已经手动重跑 {n} 次，到上限了，明天再来。',
  'agentReview.rerun.err.budgetReserved': '今天剩下的 AI 额度留给新工单的自动预读了。手动重跑要等明天——你什么都没做错。',

  // D. 上一轮的预读。默认折叠，且只能看不能答（历史题连 key 都没有）。
  'agentReview.history.show': '看上 {n} 轮的预读',
  'agentReview.history.hide': '收起历史',
  'agentReview.history.round': '第 {n} 轮',
  'agentReview.history.supersededAt': '{when} 被覆盖',
  'agentReview.history.readOnly': '已被覆盖：只能看，不能答',
  'agentReview.history.directives': '那一轮带着的命令：{list}',
  'agentReview.history.noDraft': '那一轮没有提工作项草案。',

  // E. 工作项草案：agent 提议，人按一下。
  'agentReview.draft.title': 'AI 建议立一条工作项',
  'agentReview.draft.kind': '类型：{kind}',
  'agentReview.draft.kind.bug': '缺陷',
  'agentReview.draft.kind.maintenance': '维护',
  'agentReview.draft.kind.tech_debt': '技术债',
  'agentReview.draft.scope': '范围：',
  'agentReview.draft.stakeholders': '相关方：',
  'agentReview.draft.why': '为什么值得单独立一条：',
  'agentReview.draft.adopt': '受理时按这份草案建工作项',
  // 「采纳前要说清会发生什么」就落在这一句上：建什么、挂到哪、归属记谁。
  'agentReview.draft.adoptHint': '勾上以后，按下「提交裁决」会建一条工作项：标题与范围取自上面这份草案，关联到这张工单，归属（提出人）记你——不是 AI。不勾就按老办法建：只搬运工单标题与你的问答。',
  'agentReview.draft.blockedByExisting': '这张工单已经关联了工作项 {no}，所以没有再建一条，草案也没有被采纳。',
  'agentReview.draft.adopted': '已按草案建工作项 {no}，并关联到本工单。',
  'agentReview.err.noDraft': '这份预读里没有可采纳的工作项草案（可能它刚被新一轮覆盖了）。刷新看看。',
  'agentReview.err.draftNeedsAccept': '工作项只在「受理」时建。要采纳这份草案，先把动作选成受理。',

  // ── 第一百一十一批 D（OQ-C50）：按 agent 的问题发 request_info ─────────────
  // 设计文档声明了两批以上、而实现从未存在的那一条：审批人每次都把 agent 已经写好
  // 的问题**手工重打一遍**。草案可编辑后再发，发出去的是**他**写的那一版。
  'agentReview.ask.useDraft': '按 agent 的问题请求补充',
  'agentReview.ask.hint': '把上面这些问题填进批注，作为一次「请求补充」发给提交人。发之前你可以随意改写——发出去的是**你**写的那一版。',
  'agentReview.ask.header': '请补充以下事实：',
  'agentReview.ask.footer': '补齐后请在本工单上回复。',
  'agentReview.ask.filled': '批注已按 agent 的 {n} 条问题填好。改完再发。',
  'agentReview.ask.overwriteTitle': '批注里已经有字了',
  'agentReview.ask.overwriteBody': '填入草案会覆盖你已经写下的 {n} 个字。本工具不替你合并——合并出来的那段话没有作者。',
  'agentReview.ask.overwriteOk': '覆盖并填入',
  'agentReview.ask.cancel': '取消',
  'agentReview.ask.needsRequestInfo': '这几条问的是**提交人**，所以只随「请求补充」发出——点这个按钮会把动作切过去。',
  // 发之前要说清：工单会转到哪个状态、提交人会收到什么。
  'agentReview.ask.willHappen': '提交之后：这张工单转为「待补充信息」，你写的这段话成为一条工单反馈，提交人的铃铛上会出现一条通知（超过一天没登录还会收到提醒信）。他在这张工单上回复，工单自动转回「待审批」。',
  'agentReview.ask.sent': '已按 agent 的 {n} 条问题向提交人请求补充。',

  // F. 审批队列每行的预读徽标。「一切正常」不占像素，所以只有这三种。
  'approvals.reviewState.failed': '预读失败',
  'approvals.reviewState.escalated': 'AI 说做不了',
  'approvals.reviewState.queued': 'AI 正在读',

  // G. 管理员：agent 的逃生口报告。
  'admin.subnav.escalations': 'AI 反馈',
  'admin.escalations.title': 'AI 说它做不了的那些事',
  'admin.escalations.desc': 'agent 中途放弃时留下的报告：它做不了什么、为什么、以及给它什么它就能做了。这一页问的不是「这张单怎么办」（那在审批页），而是「这套系统交派任务的能力出了什么系统性问题」。如果「材料不够」长期占多数，问题在我们喂给它的材料，不在它。',
  'admin.escalations.empty': '没有待处置的报告。',
  'admin.escalations.filter.unacked': '待处置',
  'admin.escalations.filter.acked': '已处置',
  'admin.escalations.filter.all': '全部',
  'admin.escalations.col.at': '时间',
  'admin.escalations.col.op': '步骤',
  'admin.escalations.col.entity': '对象',
  'admin.escalations.col.reason': '原因',
  'admin.escalations.col.detail': '它说了什么',
  'admin.escalations.col.state': '处置',
  // ⚠ 与 agentReview.blocked.reason.* 刻意不共用：受众不同、措辞不同。给审批人的是
  // 「agent 说它读不下去了，因为材料里缺 X」；给管理员的是「装配器缺料」。
  'admin.escalations.reason.insufficient_context': '上下文不足（装配器缺料）',
  'admin.escalations.reason.out_of_scope': '超出可判断范围（任务定义问题）',
  'admin.escalations.reason.contradictory_instructions': '指令自相矛盾（提示词或工单打架）',
  'admin.escalations.reason.tooling_blocked': '工具受阻（取材路径不通）',
  'admin.escalations.reason.unsafe_request': '拒绝执行（判为不该做）',
  'admin.escalations.wouldNeed': '它说，给它这些就能做：',
  'admin.escalations.directives': '本轮带着的命令：',
  'admin.escalations.toolTrace': '放弃之前它查过 {n} 处：',
  'admin.escalations.byReason': '全部报告按原因：{list}',
  'admin.escalations.ack': '处置',
  'admin.escalations.ackNotePlaceholder': '处置说明（必填）：你打算怎么处理这条。例如：已立 SB-126 收口装配器的裁决清单。',
  'admin.escalations.acked': '{who} 于 {when} 处置',
  'admin.escalations.err.alreadyAcked': '这条已经被别人处置过了。刷新看看他写了什么。',
  'admin.escalations.err.emptyNote': '处置要写一句说法：一次没有说法的处置，与「没人管」在台账上分不开。',

  // G2. 管理员：敏感读面的读取记录（SB-116，第一百二十一批）。
  'admin.subnav.readAudit': '读取记录',
  'admin.readAudit.title': '谁读了这个资源',
  'admin.readAudit.desc': '敏感读面（组间线、密递、账号名册、隐藏文档）的主体审计：每一次读闸判定落一行——放行与被拒都在（被拒的那次同样是情报：谁在试）。按资源标识查，可加时间窗。记录保留 180 天，之外的已自动清理。',
  'admin.readAudit.resource': '资源标识',
  'admin.readAudit.resourceHint': '如 group-thread:7、group-threads、secret-delivery:3、admin:accounts、doc:MirrorMii/documents/contracts/x',
  'admin.readAudit.from': '起',
  'admin.readAudit.to': '止',
  'admin.readAudit.query': '查询',
  'admin.readAudit.prompt': '填一个资源标识再查——这一页没有「全量翻一遍」：审计按需查证，不做浏览器。',
  'admin.readAudit.empty': '这个窗内没有记录。注意：这不等于「没人读过」——时间窗可能不对，180 天保留期之外的行也已清理。',
  // 「闸判放行」而非「读到内容」：审计行记的是读闸判定原值——密递闸后 410 已焚、
  // 线程 id 不存在、文档读盘 404 都会落 allowed 而内容并未出网。文案越过这个取舍
  // 的边界，台账就会在密件外泄取证时说假话（第一百二十一批证伪评审抓的形状）。
  'admin.readAudit.readers': '闸判放行过的主体：{list}（放行≠内容必已送出：已焚/已删的资源放行后仍可能 410/404）。',
  'admin.readAudit.probers': '被拒但试过的：{list}。',
  'admin.readAudit.col.at': '时间',
  'admin.readAudit.col.who': '谁',
  'admin.readAudit.col.verdict': '判定',
  'admin.readAudit.col.credential': '凭据',
  'admin.readAudit.col.surface': '读面',
  'admin.readAudit.verdict.allowed': '放行',
  'admin.readAudit.verdict.denied': '被拒',
  'admin.readAudit.cred.session': '网页会话',
  'admin.readAudit.cred.key': 'API 密钥',
  'admin.readAudit.err.resource': '要先填资源标识。',
  'admin.readAudit.err.range': '起止时间写反了。',

  // G3. 管理员：响应时限的读面与裁决台（SB-190 §7.3，第二百四十六批；03-scoring D4 ①）。
  // 键放在 admin.responseSla.* 下：设计稿写的 sla.* 留给步 5 的成员面复用。
  'admin.subnav.responseSla': '响应时限',
  'admin.responseSla.title': '响应时限：谁在 1 个工作日内答了',
  'admin.responseSla.desc': '03-scoring D4 ①（10 分）的读面：期间内要求具名当事人响应的每一件事项（指派单、待补充信息、要求响应的站内信），时钟按 America/Vancouver 的工作日现算，候选由机器列，「哪一条算首次实质响应」由人裁——裁决是追加式台账里新的一行，裁错了再落一条。承接方在命令行 `sla mine` 看到的行与这里逐字同形。',
  'admin.responseSla.responders': '响应方账号 id',
  'admin.responseSla.responders.helper': '逗号分隔，如 9,12；留空 = 全部响应方（会把内部成员也算进分母）',
  'admin.responseSla.responders.all': '全部',
  'admin.responseSla.from': '起',
  'admin.responseSla.to': '止',
  'admin.responseSla.query': '查询',
  'admin.responseSla.prompt': '选响应方与期间再查——缺省期间是最近 30 天。',
  'admin.responseSla.empty': '这个窗口里没有要求响应的事项。',
  'admin.responseSla.err.range': '起止时间写反了。',
  'admin.responseSla.err.responders': '响应方要填账号 id（正整数），逗号分隔。',
  'admin.responseSla.calendar': '日历 {tz} · 假日 {holidays} · 同日阈值 {threshold} · 窗口 [{from}, {to}) · 响应方 {responders}',
  'admin.responseSla.summary.denominator': '分母',
  'admin.responseSla.summary.numerator': '分子',
  'admin.responseSla.summary.score': '分数（10 分制）',
  'admin.responseSla.summary.scoreRange': '区间（待裁未定）',
  'admin.responseSla.summary.needsRuling': '待裁',
  'admin.responseSla.summary.pending': '期限内未答',
  'admin.responseSla.summary.excluded': '不计',
  'admin.responseSla.summary.integrity': '见证不符',
  'admin.responseSla.col.channel': '通道',
  'admin.responseSla.col.ref': '事项',
  'admin.responseSla.col.responder': '响应方',
  'admin.responseSla.col.issuer': '发出方',
  'admin.responseSla.col.markedAt': '标记时刻',
  'admin.responseSla.col.deadline': '期限',
  'admin.responseSla.col.rule': '规则',
  'admin.responseSla.col.rank': '当日第几件',
  'admin.responseSla.col.state': '状态',
  'admin.responseSla.col.candidates': '候选',
  'admin.responseSla.col.rulings': '裁决',
  'admin.responseSla.col.action': '操作',
  'admin.responseSla.frozen': '已冻结',
  'admin.responseSla.witnessMismatch': '标记与见证不符——先查库再读分',
  'admin.responseSla.kind.substantive': '实质响应（含结论或数据）',
  'admin.responseSla.kind.not_substantive': '非实质（仅确认收到，不计）',
  'admin.responseSla.kind.provisional': '暂定（给了明确下一步，须在承诺日内兑现）',
  'admin.responseSla.kind.honoured': '已兑现（指向那条暂定候选）',
  'admin.responseSla.kind.not_honoured': '未兑现（回溯计逾期）',
  'admin.responseSla.kind.extend': '顺延（阻塞持续期间，按工作日数）',
  'admin.responseSla.kind.exclude': '移出分母（问错、重复、发出方撤问）',
  'admin.responseSla.ruling.title': '裁决',
  'admin.responseSla.ruling.kind': '裁决种类',
  'admin.responseSla.ruling.candidate': '候选',
  'admin.responseSla.ruling.promisedBy': '承诺兑现日',
  'admin.responseSla.ruling.extendDays': '顺延工作日数',
  'admin.responseSla.ruling.blockerRef': '阻塞登记的工单编号',
  'admin.responseSla.ruling.reason': '理由（必填）',
  'admin.responseSla.ruling.reasonHelper': '裁决人自己的话，≤ 2000 字节；它会随读数归档进验收纪要。',
  'admin.responseSla.ruling.noCandidate': '这件事项没有可选的候选（已兑现／未兑现只能指向已裁为暂定的候选）。',
  'admin.responseSla.ruling.submit': '落裁决',
  'admin.responseSla.ruling.done': '裁决已落（追加式：历史行留作台账）。',
  'admin.responseSla.err.RULE_VIOLATION': '裁决的形状被服务端拒绝（不适用的字段必须缺席；provisional 要承诺日；extend 要日数与阻塞单）',
  'admin.responseSla.err.NOT_FOUND': '这件事项已不在（窗口外或库变了）——重查一次。',

  // ── SB-190 步 5（第二百四十七批）：响应时限，成员面与管理面**共用**的两族标签 + 钟点条 ──
  // state / rule 两族从 admin.responseSla.* 搬到 sla.*：钟点条（工单详情、站内信行、强读闸、
  // 提交页 201）与管理页印的是同一个判定、同一条规则，标签只许有一份（pages/responseSla.mjs）。
  // 模板键 keys.test 看不见，responseSla.test.mjs 与 adminResponseSla.test.mjs 逐值钉住。
  'sla.state.on_time': '达标',
  'sla.state.on_time_provisional': '暂计达标（承诺日内）',
  'sla.state.late': '逾期',
  'sla.state.needs_ruling': '待裁',
  'sla.state.pending': '期限内未答',
  'sla.state.excluded': '不计',
  'sla.rule.1bd': '次一工作日同一钟点',
  'sla.rule.1bd_shift': '非工作日标记，自下一工作日 00:00 起',
  'sla.rule.1bd_defer': '同日第 4 件起，顺延一个工作日',
  // 钟点条：「截止 … · 规则 1bd_defer（该日第 4 件）」（设计 §8）。截止时刻按读者本地时区印
  // （fmtTime），日历时区的 SOP-11 帧挂在 title 上；规则印**码**，句子作 title。
  'sla.bar.due': '截止 {t}',
  'sla.bar.rule': '规则 {rule}',
  'sla.bar.rank': '（该日第 {n} 件）',
  'sla.bar.extended': '顺延后截止 {t}',
  'sla.bar.frozen': '期限已随裁决冻结',

  // H. 管理页：失败作业的重排与空壳能力标注。
  'admin.settings.jobs.requeue': '重排',
  'admin.settings.jobs.requeueForce': '仍然重排',
  'admin.settings.jobs.requeued': '已排一条新作业 #{id}。',
  'admin.settings.jobs.failClass.transient': '可重试',
  'admin.settings.jobs.failClass.permanent': '重试徒劳',
  'admin.settings.jobs.failClass.account': '账户不让用',
  'admin.settings.jobs.failClass.unknown': '原因不明',
  'admin.settings.jobs.err.notTerminal': '这条作业还没结束（排队中或正在跑），不需要重排。',
  'admin.settings.jobs.err.futile': '这条是请求本身被拒，重排必然同样被拒。真要再试一次，按「仍然重排」。',
  'admin.settings.op.unwired': '无调用方',
  'admin.settings.op.unwiredHint': '这一项在配置表里，但全仓没有任何调用方——改它不会有任何效果。它不是"暂时关掉了"，没有开关可开。',

  // ── SB-197 S3b（第二百九十二批）：资产对账表四态记录 ──────────────────────────
  'shell.nav.assetProgress': '资产对账',
  'assetProgress.title': '美术—程序资产对账 · 四态记录',
  'assetProgress.subtitle': '每一格是该资产该态的最新一条记录（值 · 记录人 · 日期 · 证据）。记一条要证据；正典在仓内，工作空间按批拉回，台账 §5 随之更新。',
  'assetProgress.role': '本会话可记：{role}',
  'assetProgress.roleNone': '本岗位只读（不能记态）',
  'assetProgress.summary': '{rows} 行 · {events} 条记录',
  'assetProgress.sectionSummary': '{count} 行',
  'assetProgress.done': '{done}／{total} 已完成',
  'assetProgress.rowsEmpty': '镜像里没有行——台账主表尚未随部署刷进来。',
  'assetProgress.col.ma': 'MA',
  'assetProgress.col.deliverer': '交付方',
  'assetProgress.col.version': '启用',
  'assetProgress.col.history': '历史',
  'assetProgress.state.art_delivered': '美术已交',
  'assetProgress.state.program_received': '程序已收',
  'assetProgress.state.program_integrated': '程序已接',
  'assetProgress.state.screen_verified': '画面已验',
  'assetProgress.value.unknown': '未知',
  'assetProgress.value.not_started': '未开始',
  'assetProgress.value.partial': '部分',
  'assetProgress.value.blocked': '受阻',
  'assetProgress.value.pending_review': '待覆核',
  'assetProgress.value.done': '已完成',
  'assetProgress.value.not_applicable': '不适用',
  'assetProgress.record': '记',
  'assetProgress.none': '—',
  'assetProgress.expandAll': '全部展开',
  'assetProgress.collapseAll': '全部收起',
  'assetProgress.reload': '刷新',
  'assetProgress.dialog.title': '记一条：{ma} · {state}',
  'assetProgress.dialog.chain': '接在 #{id} 之后',
  'assetProgress.dialog.chainFirst': '首条（该格尚无记录）',
  'assetProgress.dialog.value': '值',
  'assetProgress.dialog.evidence': '证据（必填：工单号、站内信号、截图路径……一句可查的东西）',
  'assetProgress.dialog.assetVersion': '资产版次（如 art-v1）',
  'assetProgress.dialog.usage': '用途（用途绑定之后填）',
  'assetProgress.dialog.note': '短注',
  'assetProgress.dialog.submit': '记下',
  'assetProgress.evidenceRequired': '没有证据的状态不是状态——请填证据。',
  'assetProgress.history.title': '{ma} 的记录（新在前）',
  'assetProgress.history.empty': '尚无记录。',
  'assetProgress.err.stale': '别人刚记了一条，你接的不是最新——已刷新，请再记一次。',
  'assetProgress.err.forbidden': '本岗位不能记这一态。',
  'assetProgress.err.rule': '服务端拒绝了这条记录（形状、枚举、证据或 MA 不在镜像）。',
  'assetProgress.err.notFound': '这个组没有发布台账页，或本岗位看不见它。',
  'assetProgress.err.failed': '记录失败，请重试。',
  // 第二百九十四批（需求方指令）：MA 可点开看资产详情
  'assetProgress.detail.title': '{ma} 资产详情',
  'assetProgress.detail.empty': '镜像里没有这一行的明细（台账无明细块，或尚未随部署刷新）。',
  'assetProgress.col.field': '项',
  'assetProgress.col.value': '值',
  'assetProgress.col.purpose': '用途',
  'assetProgress.usage.unbound': '（未绑定用途）',

  // ── SB-201 S3（第三百零八批，需求方指令「类似资产对账的 tab」）：功能代码妥善率表三态记录 ──
  'shell.nav.featureProgress': '功能对账',
  'featureProgress.title': '功能代码妥善率 · 三态记录',
  'featureProgress.subtitle': '每一格是该功能点该态的最新一条记录（值 · 记录人 · 日期 · 证据）。「已实现」「通过」要证据，建议锚定 git 提交；正典在仓内，工作空间按批拉回，功能表随之更新。',
  'featureProgress.role': '本会话可记：{role}',
  'featureProgress.roleNone': '本岗位只读（不能记态）',
  'featureProgress.summary': '{rows} 个功能点 · {events} 条记录',
  'featureProgress.sectionSummary': '{count} 节点（父 {parents}／子 {children}）',
  // 第三百一十三批（S4）：二级展开——父自己也是节点、不由子派生；父子平等计入分母
  'featureProgress.childrenOpen': '展开 {n} 子项',
  'featureProgress.childrenClose': '收起子项',
  'featureProgress.done': '{done}／{total}',
  'featureProgress.rowsEmpty': '镜像里没有行——功能表主表尚未随部署刷进来。',
  'featureProgress.col.fp': 'FP',
  'featureProgress.col.sentence': '功能点',
  'featureProgress.col.source': '规格出处',
  'featureProgress.col.owner': '责任岗',
  'featureProgress.col.history': '历史',
  'featureProgress.state.implemented': '实现',
  'featureProgress.state.self_tested': '自测',
  'featureProgress.state.qa_passed': 'QA',
  'featureProgress.value.not_started': '未开始',
  'featureProgress.value.partial': '部分',
  'featureProgress.value.done': '已实现',
  'featureProgress.value.none': '未',
  'featureProgress.value.passed': '通过',
  'featureProgress.record': '记',
  'featureProgress.none': '—',
  'featureProgress.expandAll': '全部展开',
  'featureProgress.collapseAll': '全部收起',
  'featureProgress.reload': '刷新',
  'featureProgress.dialog.title': '记一条：{fp} · {state}',
  'featureProgress.dialog.chain': '接在 #{id} 之后',
  'featureProgress.dialog.chainFirst': '首条（该格尚无记录）',
  'featureProgress.dialog.value': '值',
  'featureProgress.dialog.evidence': '证据（必填：git 提交 sha 或 PR，其次工单号、站内信号——一句可查的东西）',
  'featureProgress.dialog.evidenceOptional': '证据（可选）',
  'featureProgress.dialog.evidenceHint': '这不像 git 提交（无 sha／PR）——可以记，但请尽量锚定到提交。',
  'featureProgress.dialog.note': '短注',
  'featureProgress.dialog.submit': '记下',
  'featureProgress.evidenceRequired': '「已实现」「通过」没有证据不算——请填 git 提交或别的可查证据。',
  'featureProgress.history.title': '{fp} 的记录（新在前）',
  'featureProgress.history.empty': '尚无记录。',
  'featureProgress.err.stale': '别人刚记了一条，你接的不是最新——已刷新，请再记一次。',
  'featureProgress.err.forbidden': '本岗位不能记这一态。',
  'featureProgress.err.rule': '服务端拒绝了这条记录（形状、枚举、证据或 FP 不在镜像）。',
  'featureProgress.err.notFound': '这个组没有发布功能表页，或本岗位看不见它。',
  'featureProgress.err.failed': '记录失败，请重试。',
  // ── SB-159（第三百八十二批）：列表分页口径——「这一页 N 条」与「一共 N 条」必须分得开 ──
  // 复审：取数结局的三句按页面分前缀（pagingNotice 的 ns）——量词（张／条）与「点重试能补齐」都只对某一页成立。
  'approvals.total': '本视图列出 {n} 张',
  'approvals.paging.capped': '只列出了前 {n} 张（服务端共 {total} 张）——单次加载的页数上限到了，请用筛选条件缩小范围。',
  'approvals.paging.maybeMore': '列出了 {n} 张，但服务端没有说是否还有更多（旧版服务端）——这份清单可能不全。',
  'approvals.paging.drift': '取到 {n} 张，服务端计 {total} 张——加载途中清单有变动，或有一部分没取到。点重试重新取全。',
  'tickets.paging.drift': '此处列出 {n} 张，服务端计 {total} 张——这份清单不全。若是加载途中有工单新增或变动，点重试就能补齐；若是服务端给这一页设了上限，重试补不回来，请告诉管理员。',
  'paging.hasMore': '还有更多没列出来（本页上限 {n} 条）。',
  'notif.loadMore': '加载更多（更早的通知）',
  'notif.loadMoreBusy': '正在取…',
  'notif.loadMoreError': '这一页没取回来——不是没有了，是没取到。再点一次重试。',
  'notif.unreadOutside': '另有 {n} 条未读不在上面——点「加载更多」往前翻。',
  // 没有「加载更多」时（旧版服务端、服务端说没有更多、或菜单开着时角标被轮询抬高——缺的那几条是更新的）。
  'notif.unreadOutsideReopen': '另有 {n} 条未读不在上面——重新打开铃铛刷新。',
  'pager.prev': '上一页',
  'pager.next': '下一页',
  'admin.escalations.range': '第 {from}–{to} 条，共 {total} 条',
  'admin.escalations.unacked': '待处置共 {n} 条',
  'admin.repos.branchesTruncated': '分支太多：下拉里只列出了 {n} 个（仓里共 {total} 个）——要找的分支可能不在里面。',
  'admin.repos.defaultBranchNotListed': '列出的分支里没有 main／master——它可能在没列出的那部分里。下面打开的是 {name}，不是默认分支。',
  'admin.repos.noDefaultBranch': '这个仓没有 main／master 分支，下面打开的是第一个分支 {name}。',
  'admin.escalations.totalUnknown': '服务端没有给出总数（旧版服务端）——这里列出的 {n} 条之外可能还有，不能当成全部。',
  'admin.readAudit.limitReached': '已达单次上限 {n} 条：这一页最早的一条在 {oldest}，更早的记录没有列出——把「止」收到这个时刻之前再查一次。',
  'admin.readAudit.pageOnly': '（仅本页）',
  'due.loadFailed': '到期动作没取回来——这不等于「没有到期的事」。点重试再取一次。',
  'work.backlogsLoadFailed': '工作项清单没取回来——这不等于「没有可登记的工单」。刷新页面再试一次。',
};
